import React, { useState, useEffect, Fragment } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Switch } from '@mui/material';
import moment from 'moment';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    //GridToolbarDensitySelector,
    useGridApiContext,
    useGridApiRef,
    //   GridCsvExportOptions,
    //   GridCsvGetRowsToExportParams,
    gridVisibleSortedRowIdsSelector
} from '@mui/x-data-grid';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Stack, Alert, Collapse, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Tooltip, ButtonGroup } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import SelfSizingTextField from "./Widgets/selfSizingTextField";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import useGridColumnSetup, { saveApp, useMenuItemProps, useHandleMultiSelectChange, handleBooleanRadioButtonChange, handleSecurityBreachChange } from '../hooks/useAppsLogic';
import { Controller } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import _without from "lodash/without";
import FormLabel from '@mui/material/FormLabel';


const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: selectedColor,
    },
}));


var initialGridState;
initialGridState = {
    pagination: {
        pageSize: 1000,

    },
    //   ...applicationData.initialState,
    //   filter: {
    //     ...applicationData.initialState?.filter,
    //     filterModel: {
    //       items: [
    //         filterItem,
    //       ],
    //     },
    //   },
};

const columns1 = [
    { field: 'id' },
    { field: 'username', width: 150 },
    { field: 'age', width: 80, type: 'number' },
];
LoadingOverlay.propTypes = undefined
const DarkBackgroundDiv = DarkBackground
const buttonGroupOptions = ['Institutional PIAs', 'Master PIAs', 'All PIAs'];
// async function GetPiaData() {

//     const accessToken = localStorage.getItem("userToken");
//     var response = await fetch('pia?userInfo=' + localStorage.getItem("userEmail"), {
//         method: 'GET',
//         withCredentials: true,
//         credentials: 'include',
//         headers: {
//             'Authorization': accessToken,
//             'Content-Type': 'application/json'
//         }
//     });
//     return response.json();
// };
const handlebgClick = () => {
    //console.info(`You clicked ${buttonGroupOptions[selectedIndex]}`);
};
const useValidationSchema = () => {

    //const UrlRe = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$|^$/gm

    const UrlRe = RegExp('^$|(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
    const validationSchema = Yup.object().shape({
        id: Yup.number(),

        vendorId: Yup.number()
            .required('Vendor is required')
            .min(1, 'Please select a vendor'),
        itOwnerId: Yup.number(),
        collectionModeId: Yup.number(),
        collectionModeOther: Yup.string()
            .nullable()
            .max(250, 'Other Collection Mode must not exceed 150 characters'),
        name: Yup.string()
            .required('Application Name is required')
            .max(150, 'Application must not exceed 150 characters'),
        url: Yup.string()
            .required('URL is required')
            .matches(UrlRe, 'URL is not valid')
            .min(6, 'URL must be at least 6 characters')
            .max(150, 'URL must not exceed 150 characters'),
        description: Yup.string()
            .required('Description is required')
            .max(1000, 'Description  must not exceed 1000 characters'),
        cloudHosted: Yup.boolean()
            .required('Cloud Hosted is required')
            .typeError('Cloud Hosted must be Yes or No'),
        cloudProviderId: Yup.string()
            .nullable(),
        cloudProvider: Yup.string()
            .max(150, 'Cloud Provider must not exceed 150 characters')
            .nullable(),
        startDate: Yup.string()
            .nullable()
            .test("startDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        endDate: Yup.string()
            .nullable()
            .test("endDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        other: Yup.string()
            .nullable(),
        applicableDepartmentsOther: Yup.string()
            .max(350, 'Field cannont exceed 350 characters')
            .nullable(),
        generalApplicationNotes: Yup.string()
            .max(2000, 'Field cannont exceed 2000 characters')
            .nullable(),
        other: Yup.string()
            .nullable()
            .max(1000, 'Other data collection must not exceed 1000 characters'),
        dataCollectionNotes: Yup.string()
            .nullable()
            .max(2000, 'Data collection notes must not exceed 2000 characters'),
        dataProtectionNotes: Yup.string()
            .nullable()
            .max(2000, 'Data protection notes must not exceed 2000 characters'),

        privacyUrl: Yup.string()
            .matches(UrlRe, 'URL is not valid')
            .max(150, 'URL must not exceed 150 characters')
            .nullable(),
        privacyNotification: Yup.string()
            .nullable()
            .max(1000, 'Privacy Notification must not exceed 1000 characters'),
        privacyTraining: Yup.string()
            .nullable()
            .max(1000, 'Privacy Training must not exceed 1000 characters'),
        subcontractors: Yup.string()
            .nullable()
            .max(1000, 'Subcontractors must not exceed 1000 characters'),
        subcontractorDataProtection: Yup.string()
            .nullable(),
        // .required('Subcontractor Data Protection is required')
        // .typeError('Subcontractor Data Protection must be Yes, No or N/A'),
        securityBreachInt: Yup.string()
            .nullable(),
        securityBreachDescription: Yup.string()
            .nullable()
            .max(1000, 'Security Breach Plan must not exceed 1000 characters'),
        auditFrequencyId: Yup.string()
            .nullable()
            .typeError('Please select Audit Frequency '),
        auditFrequencyOther: Yup.string()
            .nullable(true)
            .max(150, 'Other Audit Frequency must not exceed 150 characters')
            .when("auditFrequencyId", {
                is: (val) => val === -1,
                then: Yup.string().required("Other is selected, please provide other value"),
                otherwise: Yup.string().notRequired().nullable(),
            }),
        lastAuditDate: Yup.string()
            .nullable()
            .test("lastAuditDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        securityBreachPlan: Yup.string()
            .nullable()
            .max(2000, 'Security Breach Plan must not exceed 2000 characters'),
        privacyPracticeReview: Yup.string()
            .nullable()
            .max(1000, 'Privacy Practice Review must not exceed 1000 characters'),
        vendorSaleAssurance: Yup.string()
            .nullable()
            .max(1000, 'Vendor Sale Assurance must not exceed 1000 characters'),
        dataBackup: Yup.string()
            .nullable()
            .max(2500, 'Data Backup and storage must not exceed 2500 characters'),
        lossProtection: Yup.string()
            .nullable()
            .max(2500, 'Loss Protection must not exceed 2500 characters'),
        dataSinglePurpose: Yup.bool()
            // .required('Data Single Purpose is required')
            // .typeError('Data Single Purpose must be Yes or No'),
            .nullable(),
        dataRetentionPolicy: Yup.string()
            .nullable()
            .max(2500, 'Data Retention Policy must not exceed 2500 characters'),
        dataRetentionLength: Yup.string()
            .nullable()
            .max(1000, 'Data Retention Length must not exceed 1000 characters'),
        dataAfterDiscontinuing: Yup.string()
            .nullable()
            .max(2500, 'Data Discontuance must not exceed 2500 characters'),
        dataHandlingNotes: Yup.string()
            .nullable()
            .max(2000, 'Data handling notes must not exceed 2000 characters'),
        complianceNotes: Yup.string()
            .nullable()
            .max(2000, 'Compliance notes must not exceed 2000 characters'),
        approvalNotes: Yup.string()
            .nullable()
            .max(2000, 'Approval notes must not exceed 2000 characters'),



        gDPRCompliant: Yup.boolean()
            .nullable(),
        internetPipublished: Yup.boolean(),
        notApprovedReason: Yup.string()
            .nullable()
            .max(2500, 'Rationale for not approving must not exceed 2500 characters'),
        approverId: Yup.string()
            .nullable(),
        commonSenseRating: Yup.number()
            .nullable()
            .typeError('Common Sense must be a number')
            .max(100, 'Common Sense must not exceed 100 (percentage)'),
        commonSense: Yup.number()
            .nullable(true)
            .typeError('Common Sense must be a number')
            .max(2, 'Invalid value'),
        evalUrl: Yup.string()
            .nullable(true)
            .matches(UrlRe, 'URL is not valid')
            .max(350, 'URL must not exceed 350 characters'),
        gdprComplianceLevel: Yup.number()
            .nullable()
            .typeError('GDPR Compliance Level must be a number'),
        coppa: Yup.number()
            .nullable()
            .typeError('COPPA must be a number'),
        vendorConfirmed: Yup.boolean()
            .nullable()
            .typeError('Vendor Confirmation must be Yes or No'),
        dataLocationOther: Yup.string()
            .nullable(true)
            .notRequired()
            .max(250, 'Data Location must not exceed 250 characters'),
        hasExternalLLMs: Yup.boolean()
            .nullable()
            .typeError('External LLMs must be Yes or No'),
        llmProviders: Yup.string()
            .nullable()
            .max(1000, 'LLM Providers must not exceed 1000 characters'),
        llmTraining: Yup.boolean()
            .nullable()
            .typeError('LLM Training must be Yes or No'),
        llmDataShared: Yup.boolean()
            .nullable()
            .typeError('LLM Data Shared must be Yes or No'),
        llmUnder18Treatment: Yup.string()
            .nullable()
            .max(1000, 'LLM Under 18 Treatment must not exceed 1000 characters'),
        llmRestrict: Yup.string()
            .nullable()
            .max(1000, 'Restriction approach must not exceed 1000 characters'),


    });
    return validationSchema;
}
export default function Pias() {
    const accessToken = localStorage.getItem("userToken");
    const [open, setOpen] = React.useState(false);

    var validationSchema = useValidationSchema();
    const [returnData, setreturnData] = useState(null);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deleteName, setDeleteName] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [successDialogOpen, setSuccessDialogOpen] = React.useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
    const [startDate, setStartDate] = React.useState(new Date());
    const [approvalDate, setApprovalDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState('');
    const [gradesSelected, setgradesSelected] = useState([]);
    const [studentInfoSelected, setstudentInfoSelected] = useState([]);
    const [staffInfoSelected, setstaffInfoSelected] = useState([]);
    const [parentInfoSelected, setparentInfoSelected] = useState([]);
    const [alumniInfoSelected, setalumniInfoSelected] = useState([]);
    const [volunteerInfoSelected, setVolunteerInfoSelected] = useState([]);
    const [areaOfUseSelected, setareaOfUseSelected] = useState([]);
    const [collectionModesSelected, setCollectionModesSelected] = useState([]);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [dataCollectionOpen, setDataCollectionOpen] = useState(false);
    const [dataProtectionOpen, setDataProtectionOpen] = useState(false);
    const [dataHandlingOpen, setDataHandlingOpen] = useState(false);
    const [otherOpen, setOtherOpen] = useState(false);
    const [genAIOpen, setGenAIOpen] = useState(false);
    const [approvalOpen, setApprovalOpen] = useState(false);
    const [subcontractorDataProtection, setSubcontractorDataProtection] = useState('0');
    const [commonSense, setCommonSense] = useState('0');
    const [securityBreachInt, setSecurityBreachInt] = useState(false);
    const [cloudHosted, setCloudHosted] = useState(false);
    const [otherAuditShow, setotherAuditShow] = useState(false);
    const [otherDepartmentsShow, setotherDepartmentsShow] = useState(false);
    const [lastAuditDate, setLastAuditDate] = React.useState('');
    const [dataSinglePurpose, setDataSinglePurpose] = React.useState(false);
    const [dataLocationSelected, setdataLocationSelected] = useState([]);
    const [gDPRCompliant, setgDPRCompliant] = useState(false);
    const [hasExternalLLMs, setHasExternalLLMs] = useState(false);
    const [llmroviders, setllmProviders] = useState('');
    const [llmTraining, setllmTraining] = useState('');
    const [llmDataShared, setllmDataShared] = useState(false);
    const [llmUnder18Treatment, setllmUnder18Treatment] = useState('');
    const [llmRestrict, setllmRestrict] = useState('');
    const [internetPIPublished, setinternetPIPublished] = useState(false);
    const [dataBreachCompliant, setdataBreachCompliant] = useState(false);
    const [approved, setapproved] = useState(false);
    const [notApproved, setnotApproved] = useState(false);
    const [gradesNASelected, setgradesNASelected] = useState(false);
    const [studentInfoNASelected, setstudentInfoNASelected] = useState(false);
    const [staffInfoNASelected, setstaffInfoNASelected] = useState(false);
    const [parentInfoNASelected, setparentInfoNASelected] = useState(false);
    const [alumniInfoNASelected, setalumniInfoNASelected] = useState(false);
    const [volunteerInfoNASelected, setVolunteerInfoNASelected] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isAdding, setIsAdding] = useState(false);
    const [lastUpdatedDate, setLastUpdatedDate] = useState(new Date());
    const [completedBy, setCompletedBy] = useState('');
    const [isSchoolRecord, setIsSchoolRecord] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [tenantPiaId, setTenantPiaId] = useState(0);
    const [cloudProviderOtherValue, setCloudProviderOtherValue] = useState('');
    const [cloudProviderOtherShow, setCloudProviderOtherShow] = useState(false);
    const [bgOpen, setBgOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(2);
    const [vendorConfirmed, setVendorConfirmed] = React.useState(false);
    const [coppa, setCoppa] = React.useState('0');
    const [gDPRComplianceLevel, setGDPRComplianceLevel] = React.useState('0');
    const [policyLastUpdated, setPolicyLastUpdated] = React.useState('');


    var applicationData = [];
    var vendorsToDisplay = [];
    var itOwners = [];
    var collectionModes = [];
    var grades = [];
    var studentItems = [];
    var staffItems = [];
    var parentItems = [];
    var alumniItems = [];
    var volunteerItems = [];
    var areaOfUseItems = [];
    var auditFrequencyList = [];
    var dataLocationItems = [];
    var cloudProviderItems = [];
    var collectionModeItems = [];
    var approverList = [];
    var currentUser = { isSuperAdmin: false };

    const filterItems = [[{ columnField: 'isSchoolRecord', operatorValue: 'is', value: 'true' }], [{ columnField: 'isSchoolRecord', operatorValue: 'is', value: 'false' }], []];
    const [filterItem, setFilterItem] = useState(filterItems[2]);

    const getProperUrl = (value) => {
        //if value is undefined, return empty string
        if (value === undefined) {
            return '';
        }
     
        //if string does not start with http or https, add it
        if (value !== null && value !== undefined) {
            if (!value.startsWith('http://') && !value.startsWith('https://')) {
                value = "https://" + value;
            }
        }
        // var urlRegex = new RegExp('/^((http):\/\/)/');
        // if(!urlRegex.test(value)) { value = "https://" + value; }
        return value;
    };
    const CustomDisableInput = styled(TextField)(() => ({
        ".MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#888",
            color: "#888"
        }
    }));
    const CustomDisableInputSelect = styled(Select)(() => ({
        ".MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#888",
            color: "#888"
        }
    }));
    const handleCommonSenseChange = (event, newValue) => {

        setCommonSense(newValue);
    };
    const handleSubcontractorRadioButtonChange = (event, setFunction) => {
        setFunction(event.target.value);
    };
    const handleinternetPiChange = (event) => {
        setinternetPIPublished(event.target.checked);
    };
    const onSubmit = async (data, mode) => {

        if (currentUser.isSuperAdmin) {
            if (window.confirm('Are you sure you want to save this Master Record?')) {

            } else {
                // Do nothing!
                return;
            }
        }

        if (mode !== 1) {
            setOpen(false);
        }

        setIsLoading(true);
        setIsSaving(true);
        data.saving = true;

        data.accessToken = accessToken;

        data.tenantPiaId = tenantPiaId;

        //Handle N/A selections
        data.gradesSelected = gradesSelected;
        if (gradesSelected.indexOf('Select All') !== -1) {
            data.gradesSelected = grades;
        }
        if (gradesNASelected === true) {
            data.gradesSelected = ['N/A'];
        }


        if (staffInfoNASelected === true) {
            data.staffInfoSelected = ['N/A'];
        }
        else {
            //check to see if Select All is selected
            if (staffInfoSelected.indexOf('Select All') !== -1) {
                data.staffInfoSelected = staffItems;
            }
            else {
                data.staffInfoSelected = staffInfoSelected;
            }
        }

        if (studentInfoNASelected === true) {
            data.studentInfoSelected = ['N/A'];
        }
        else {
            //check to see if Select All is selected
            if (studentInfoSelected.indexOf('Select All') !== -1) {
                data.studentInfoSelected = studentItems;
            }
            else {
                data.studentInfoSelected = studentInfoSelected;
            }
        }

        if (parentInfoNASelected === true) {
            data.parentInfoSelected = ['N/A'];
        }
        else {
            //check to see if Select All is selected
            if (parentInfoSelected.indexOf('Select All') !== -1) {
                data.parentInfoSelected = parentItems;
            }
            else {
                data.parentInfoSelected = parentInfoSelected;
            }
        }

        if (alumniInfoNASelected === true) {
            data.alumniInfoSelected = ['N/A'];
        }
        else {
            //check to see if Select All is selected
            if (alumniInfoSelected.indexOf('Select All') !== -1) {
                data.alumniInfoSelected = alumniItems;
            }
            else {
                data.alumniInfoSelected = alumniInfoSelected;
            }
        }

        if (volunteerInfoNASelected === true) {
            data.volunteerInfoSelected = ['N/A'];
        }
        else {
            //check to see if Select All is selected
            if (volunteerInfoSelected.indexOf('Select All') !== -1) {
                data.volunteerInfoSelected = volunteerItems;
            }
            else {
                data.volunteerInfoSelected = volunteerInfoSelected;
            }
        }

        data.areaOfUseSelected = areaOfUseSelected;
        data.dataLocationSelected = dataLocationSelected;
        data.collectionModesSelected = collectionModesSelected;

        data.cloudHosted = data.cloudHosted === '1';

        data.subcontractorDataProtection = subcontractorDataProtection; //= data.subcontractorDataProtection === '1';
        //forcing using state - was buggy relying on data here - yup issue?

        data.notApproved = notApproved;
        data.approved = approved;

        data.securityBreachInt = securityBreachInt;
        if (data.approved === false) {
            data.approvalDate = null;
        }

        //null out approval date if empty
        if (data.approvalDate === "") {
            data.approvalDate = null;
        }

        //set approver and cloudHostId to null if blank
        data.approverId = data.approverId === '' ? null : data.approverId;
        data.cloudProviderId = data.cloudProviderId === '' ? null : data.cloudProviderId;
        data.cloudProvider = data.cloudProvider === '' ? null : data.cloudProvider;
        //data.cloudHosted = cloudHosted;

        if (data.startDate !== null && data.startDate !== '') {
            data.startDate = new Date(data.startDate).toISOString();
        }
        else {
            data.startDate = null;
        }
        if (data.endDate !== null && data.endDate !== '') {
            data.endDate = new Date(data.endDate).toISOString();
        }
        else {
            data.endDate = null;
        }
        if (data.lastAuditDate !== null && data.lastAuditDate !== '') {
            data.lastAuditDate = new Date(data.lastAuditDate).toISOString();
        }
        else {
            data.lastAuditDate = null;
        }
        if (data.approvalDate !== null && data.approvalDate !== '') {
            data.approvalDate = new Date(data.approvalDate).toISOString();
        }
        else {
            data.approvalDate = null;
        }
        data.commonSense = commonSense;
        data.coppa = coppa;
        data.gDPRCompliance = gDPRComplianceLevel;
        data.vendorConfirmed = vendorConfirmed;
        data.policyLastUpdated = policyLastUpdated;

        data.commonSenseScore = data.commonSenseRating === '' ? null : data.commonSenseRating;
        if (data.id === -1) { //add
            // reRender = reRender + 1;
            //setIsLoading(true);
            if (mode !== 1) {

                await saveApp(data, 'Add', showError, showSuccess, setValue, setIsLoading);
                //reRender = reRender + 1;
                setRefetch(!refetch);
            }
            else {
                await saveApp(data, 'Add', showErrorInDialog, showSuccessInDialog, setValue, setIsLoading);
                //reRender = reRender + 1;
                setRefetch(!refetch);

            }
        } else {
            if (mode !== 1) {
                await saveApp(data, 'Save', showError, showSuccess, null, setIsLoading);
             
                var x = x + 1;
                //reRender = reRender + 1;
                setRefetch(!refetch);

            }
            else {
                await saveApp(data, 'Save', showErrorInDialog, showSuccessInDialog, setIsLoading);
              
                var x = x + 1;
                //reRender = reRender + 1;
                setRefetch(!refetch);
            }

        }
        //returnData = await GetPiaData();
        applicationData = returnData.applications;
        applicationData = null;
    };


    const HandleChange = (event) => {
        useHandleMultiSelectChange(event, setgradesSelected, setstudentInfoSelected, setstaffInfoSelected, setparentInfoSelected, setalumniInfoSelected, setareaOfUseSelected, setdataLocationSelected, setgradesNASelected, setstudentInfoNASelected, setstaffInfoNASelected, setparentInfoNASelected, setalumniInfoNASelected, setotherDepartmentsShow, setCollectionModesSelected, setVolunteerInfoSelected, setVolunteerInfoNASelected, returnData);
    };
    const handleChipDelete = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };
    const handleChipDeleteForApplicableDepts = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
        if (value === 'Other') {
            setotherDepartmentsShow(false);
        }
    };
    const CustomToolbar = React.useCallback(() => {
        //const apiRef = useGridApiContext();
        const getFilteredRows = ({ apiRef }) =>
            gridVisibleSortedRowIdsSelector(apiRef);

        //   const handleExport = (options) =>
        //   apiRef.current.exportDataAsCsv(options );
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                {/* <GridToolbarFilterButton ref={setFilterButtonEl} /> */}
                {/* <GridToolbarDensitySelector />  */}
                <GridToolbarExport
                    csvOptions={{ allColumns: true, fileName: 'DataExport', getRowsToExport: getFilteredRows }}
                    printOptions={{ disableToolbarButton: true }}


                />
                {/* <Button
                {...buttonBaseProps}
                onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
              >
                Filtered rows
              </Button> */}
            </GridToolbarContainer>
        );
    }, []);
    const handlebgToggle = () => {
        setBgOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setBgOpen(false);
    };
    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setFilterItem(filterItems[index]);
        // if(index === 0){
        //   setFilterItem(filterItems[0]);
        // }
        // if(index === 1){
        //   setFilterItem(filterItems[1]);
        // }
        // if(index === 2){
        //   setFilterItem([2]);
        // }

        setBgOpen(false);
    };
    const setFilterText = (text) => {

        setFilterItem([{ columnField: 'name', operatorValue: 'contains', value: text }]);
    }
    const addApplication = (event, cellValues) => {
        setIsAdding(true);
        setValue("id", -1);
        setValue("name", '');
        setValue("vendorId", 0);
        setValue("itOwnerId", 0);
        setValue("collectionModeId", 0);
        setValue("collectionModeOther", '');
        setValue("url", '');
        setValue("description", '');
        setValue("cloudHosted", '');
        setCloudHosted(null);
        setValue("cloudProviderId", '');
        setValue("cloudProvider", '');
        setValue("startDate", '');
        setValue("endDate", '');
        setValue("other", '');
        setStartDate(null);
        setApprovalDate(null);
        setEndDate(null);
        setValue("gradesSelected", "");
        setgradesSelected([]);
        setstudentInfoSelected([]);
        setstaffInfoSelected([]);
        setparentInfoSelected([]);
        setalumniInfoSelected([]);
        setVolunteerInfoSelected([]);
        setCollectionModesSelected([]);
        setareaOfUseSelected([]);
        // setValue("privacyUrl", "");
        setValue("privacyNotification", "");
        setPolicyLastUpdated(null);
        setValue("privacyTraining", "");
        setValue("subcontractors", "");
        setSubcontractorDataProtection(null);
        setSecurityBreachInt(null);
        setDataSinglePurpose(null);
        setValue("securityBreachDescription", '');
        setValue("subcontractorDataProtection", null);
        setValue("auditFrequencyId", 0);
        setValue("auditFrequencyOther", '');
        setValue("lastAuditDate", '');
        setLastAuditDate(null);
        setValue("securityBreachPlan", '');
        setValue("privacyPracticeReview", '');
        setValue("vendorSaleAssurance", '');
        setValue("generalApplicationNotes", '');
        setValue("dataCollectionNotes", '');
        setValue("dataProtectionNotes", '');
        setValue("dataHandlingNotes", '');
        setValue("complianceNotes", '');
        setValue("dataBackup", '');
        setValue("lossProtection", '');
        setValue("dataSinglePurpose", false);
        setValue("dataRetentionPolicy", '');
        setValue("dataRetentionLength", '');
        setValue("dataAfterDiscontinuing", '');
        setValue("gDPRCompliant", false);
        setgDPRCompliant(false);
        setinternetPIPublished(false);
        setdataBreachCompliant(false);
        setapproved(false);
        setnotApproved(false);
        setValue("notApprovedReason", '');
        setValue("approverId", '');
        setValue("approvalNotes", '');
        setValue("applicableDepartmentsOther", '');
        setValue("evalUrl", '');
        setValue("dataLocationOther", '');
        setValue("commonSenseScore", 0);
        setCloudProviderOtherShow(false);
        setotherDepartmentsShow(false);
        setCommonSense('0');
        setValue("commonSenseRating", 0);
        setVendorConfirmed(false);
        setCoppa('0');
        setGDPRComplianceLevel('0');
        setHasExternalLLMs(false);
        setValue("lllmProviders", '');
        setValue("llmTraining", false);
        setValue("llmDataShared", false);
        setValue("llmUnder18Treatment", '');
        setValue("llmRestrict", '');


        if (currentUser.isSuperAdmin === false) {
            setIsSchoolRecord(true);
        }
        setdataLocationSelected([]);

        setEditOrAddTitle('Add');
        clearErrors();
        setOpen(true);
    };
    const handleClickOpen = (event, cellValues) => {

        setIsAdding(false);
        var dataRow = cellValues.row;


        var cloudProviderList = returnData.cloudProviderList;
        //find 'Other' in cloud provider list
        var otherCloudProvider = cloudProviderList.find(x => x.name === 'Other');
        //set the value of the 'Other' option
        if (otherCloudProvider) {
            setCloudProviderOtherValue(otherCloudProvider.lookupItemId);

            setCloudProviderOtherShow(dataRow.cloudProviderId === otherCloudProvider.lookupItemId);
        }
        setValue("id", dataRow.id);
        setValue("name", dataRow.name);
        setValue("vendorId", dataRow.vendorId);
        setValue("url", dataRow.url);
        setValue("description", dataRow.description);

        setValue("cloudProviderId", dataRow.cloudProviderId ?? '');
        setValue("cloudProvider", dataRow.cloudProvider ?? '');

        setPolicyLastUpdated("");
        setValue("cloudHosted", dataRow.cloudHosted ?? false);
        setValue("itOwnerId", dataRow.itOwnerId);
        setValue("collectionModeId", dataRow.collectionModeId);
        setValue("collectionModeOther", dataRow.collectionModeOther);
        setValue("startDate", dataRow.startDate);
        setValue("endDate", dataRow.endDate);
        setValue("other", dataRow.other);
        // setValue("privacyUrl", dataRow.privacyUrl);
        setValue("privacyNotification", dataRow.privacyNotification);
        setValue("privacyTraining", dataRow.privacyTraining);
        setValue("generalApplicationNotes", dataRow.generalApplicationNotes);
        setValue("dataCollectionNotes", dataRow.dataCollectionNotes);
        setValue("dataProtectionNotes", dataRow.dataProtectionNotes);
        setValue("dataHandlingNotes", dataRow.dataHandlingNotes);
        setValue("complianceNotes", dataRow.complianceNotes);
        setValue("approvalNotes", dataRow.approvalNotes);
        setValue("subcontractors", dataRow.subcontractors);
        setCloudHosted(dataRow.cloudHosted ?? false);
        setSubcontractorDataProtection(dataRow.subcontractorDataProtection);
        setSecurityBreachInt(dataRow.securityBreachInt);
        setValue("securityBreachDescription", dataRow.securityBreachDescription);
        setDataSinglePurpose(dataRow.dataSinglePurpose);
        setStartDate(dataRow.startDate);
        setApprovalDate(dataRow.approvalDate);
        setEndDate(dataRow.endDate);
        setLastAuditDate(dataRow.lastAuditDate);
        setValue("lastAuditDate", dataRow.lastAuditDate);
        setValue("securityBreachPlan", dataRow.securityBreachPlan);
        setValue("privacyPracticeReview", dataRow.privacyPracticeReview);
        setValue("vendorSaleAssurance", dataRow.vendorSaleAssurance);
        setValue("dataBackup", dataRow.dataBackup);
        setValue("lossProtection", dataRow.lossProtection);
        setValue("dataSinglePurpose", dataRow.dataSinglePurpose);
        setValue("dataRetentionPolicy", dataRow.dataRetentionPolicy);
        setValue("dataRetentionLength", dataRow.dataRetentionLength);
        setValue("dataAfterDiscontinuing", dataRow.dataAfterDiscontinuing);
        setValue("gDPRCompliant", dataRow.gDPRCompliant ?? false);
        setgDPRCompliant(dataRow.gDPRCompliant ?? false);
        setinternetPIPublished(dataRow.internetPIPublished ?? false);
        setdataBreachCompliant(dataRow.dataBreachCompliant ?? false)
        setapproved(dataRow.approved ?? false)
        setValue("approverId", dataRow.approverId ?? '');
        setnotApproved(dataRow.notApproved ?? false)
        setValue("notApprovedReason", dataRow.notApprovedReason);
        setValue("applicableDepartmentsOther", dataRow.applicableDepartmentsOther);
        setLastUpdatedDate(dataRow.lastUpdatedDate);
        setCompletedBy(dataRow.completedBy);
        setTenantPiaId(dataRow.tenantPiaId);

        if (dataRow.policyLastUpdated === '') {
            setPolicyLastUpdated(null);
        }
        else {
            setPolicyLastUpdated(dataRow.policyLastUpdated);
        }


        setVendorConfirmed(dataRow.vendorConfirmed);
        setCoppa(dataRow.coppa);
        setGDPRComplianceLevel(dataRow.gDPRCompliance);
        setCommonSense(dataRow.commonSense);

        setValue("commonSenseRating", dataRow.commonSenseScore);
        setValue("evalUrl", dataRow.evalUrl);
        setValue("contractUrl", dataRow.contractUrl);
        setValue("dataLocationOther", dataRow.dataLocationOther);
        setValue("hasExternalLLMs", dataRow.hasExternalLLMs);
        setHasExternalLLMs(dataRow.hasExternalLLMs);
        setValue("llmProviders", dataRow.llmProviders);
        setValue("llmTraining", dataRow.llmTraining);
        setllmTraining(dataRow.llmTraining);
        setValue("llmDataShared", dataRow.llmDataShared);
        setllmDataShared(dataRow.llmDataShared);
        setValue("llmUnder18Treatment", dataRow.llmUnder18Treatment);
        setValue("llmRestrict", dataRow.llmRestrict);

        if (dataRow.auditFrequencyId === null) {
            setValue("auditFrequencyId", 0);
        }
        else {
            setValue("auditFrequencyId", dataRow.auditFrequencyId);
        }
        setValue("auditFrequencyOther", dataRow.auditFrequencyOther);

        //show other box for departments (areasfuse)

        function checkOther(value) {
            return (value === 'Other');
        }
        if (dataRow.areaOfUseSelected !== null) {
            setotherDepartmentsShow(dataRow.areaOfUseSelected.find(checkOther));
        }
        else {
            setotherDepartmentsShow(false);
        }

        if (dataRow.auditFrequencyId === -1) {
            setotherAuditShow(true);
        }
        else {
            setotherAuditShow(false);
        }
        //these can't be null
        if (dataRow.gradesSelected === null) {
            setgradesSelected([]);
        } else {
            setgradesSelected(dataRow.gradesSelected);
        }

        if (dataRow.studentInfoSelected === null) {
            setstudentInfoSelected([]);
        } else {
            setstudentInfoSelected(dataRow.studentInfoSelected);
        }

        if (dataRow.staffInfoSelected === null) {
            setstaffInfoSelected([]);
        } else {
            setstaffInfoSelected(dataRow.staffInfoSelected);
        }
        if (dataRow.parentInfoSelected === null) {
            setparentInfoSelected([]);
        } else {
            setparentInfoSelected(dataRow.parentInfoSelected);
        }

        if (dataRow.alumniInfoSelected === null) {
            setalumniInfoSelected([]);
        } else {
            setalumniInfoSelected(dataRow.alumniInfoSelected);
        }

        if (dataRow.volunteerInfoSelected === null) {
            setVolunteerInfoSelected([]);
        } else {
            setVolunteerInfoSelected(dataRow.volunteerInfoSelected);
        }

        if (dataRow.areaOfUseSelected === null) {
            setareaOfUseSelected([]);
        } else {
            setareaOfUseSelected(dataRow.areaOfUseSelected);
        }
        if (dataRow.dataLocationSelected === null) {
            setdataLocationSelected([]);
        } else {
            setdataLocationSelected(dataRow.dataLocationSelected);
        }

        if (dataRow.collectionModesSelected === null) {
            setCollectionModesSelected([]);
        } else {
            setCollectionModesSelected(dataRow.collectionModesSelected);
        }

        setEditOrAddTitle('Edit');


        clearErrors();
        setOpen(true);


        if (dataRow.isSchoolRecord === false && !currentUser.isSuperAdmin) {
            setEditOrAddTitle('View');

        }
        setIsSchoolRecord(dataRow.isSchoolRecord);
    };
    const handleVendorConfirmedChange = () => {

        setVendorConfirmed(!vendorConfirmed);
    };

    const handleCoppaChange = (event, newValue) => {

        setCoppa(newValue);
    };

    const handleGDPRChange = (event, newValue) => {

        setGDPRComplianceLevel(newValue);
    };

    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        //setAccessToken(false);
        setTimeout(() => {
            setSuccessOpen(false);
        }, 3000);
    };

    const showSuccessInDialog = message => {
        setSuccessDialogOpen(true);
        setSuccessMessage(message);
        //setAccessToken(false);
        setTimeout(() => setSuccessDialogOpen(false), 3000);
    };

    const showError = () => {
        setErrorOpen(true);
        setTimeout(() => setErrorOpen(false), 3000);
    };

    const showErrorInDialog = () => {
        setErrorDialogOpen(true);
        setTimeout(() => setErrorDialogOpen(false), 3000);
    };


    const {
        register,
        control,
        setValue,
        getValues,
        handleSubmit,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onChange",
    });
    const saveApp = async (application, saveOrAddOrDelete, showError, showSuccess, setvalue, setIsLoading) => {

        if (setIsLoading !== null) {
            setIsLoading(true);
        }
        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'pia/';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'pia/' + application.id;
        }
        else if (saveOrAddOrDelete === 'own') {
            method = 'PUT';
            url = 'pia/own/' + application.id;
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'pia/' + application.id;
        }
        try {
            
            const requestOptions = {
                method: method,
                //headers: { 'Content-Type': 'application/json', 'Authorization': application.accessToken },
                headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem("userToken") },
                body: JSON.stringify(application)
            };
            var result;

            if (saveOrAddOrDelete === 'Add') {
                result = await fetch(url, requestOptions).then(data => data.json()).then(
                    (data) => {
                        if (setvalue !== null) {
                            setvalue("id", data);  //set value of ID so subsequent saves become updates
                        }

                        setTimeout(() => {
                            if (setIsLoading !== null) {
                                setIsLoading(false);
                            }

                        }, 3000);

                        //result = {ok: true};
                        //setIsLoading(false);
                    });
            }
            else {
                result = await fetch(url, requestOptions);
                // result = await fetch(url, requestOptions).then(
                //     (result) => {
                if (result && result.ok === false) {

                    showError();
                    if (setIsLoading !== null) {
                        setIsLoading(false);
                    }

                } else {
                    switch (saveOrAddOrDelete) {
                        case 'Save':
                            showSuccess("Update Successful");
                            break;
                        case 'Add':
                            showSuccess("New record added successfully");
                            break;
                        case 'own':
                            showSuccess("This PIA has been moved into your Institution environment and should be customized accordingly");
                            break;
                        case 'Delete':
                            showSuccess("Record Inactivated");
                            break;
                        default:
                            showSuccess("Update Successful");
                    }
                    if (setIsLoading !== null) {
                        setIsLoading(false);
                    }

                }
            }
        


        } catch (e) {
            
            showError();

        } finally {
            //for rerendering updated data
           
            //setIsLoading(false);
            //rerender(false);// x++;
        }
    }

    const handleSwitchChange = (cellValues, rowId, accessToken, showSuccess, showError) => {
        var data = { id: rowId, accessToken: accessToken };
        saveApp(data, 'own', showError, showSuccess, null, null);
        cellValues.row.isSchoolRecord = !cellValues.row.isSchoolRecord;
    }

    const handleDeleteOpen = (event, cellValues) => {
        var dataRow = cellValues.row;
        setDeleteName(dataRow.name);

        //if tenantPiaId exists, it is a tenant record, otherwise it is a master record
        if (dataRow.tenantPiaId !== null && dataRow.tenantPiaId !== 0) {
            setDeleteId(dataRow.tenantPiaId);
        }
        else {
            setDeleteId(dataRow.id);
        }

        setDeleteOpen(true);
    };

    const columns = [

        {
            field: "Actions", minWidth: 90, sortable: false, disableExport: true,

            renderCell: (cellValues) => {
                return (
                    <div>
                        <Button
                            sx={{ minWidth: 34, padding: 0 }}
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {(cellValues.row.isSchoolRecord || currentUser.isSuperAdmin) && (
                            <Button
                                sx={{ minWidth: 34, padding: 0 }}
                                variant="outlined"
                                color="primary"
                                onClick={(event) => {
                                    handleDeleteOpen(event, cellValues);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        )}
                    </div>
                );
            }
        },
        {
            field: "isSchoolRecord", headerName: 'Institution Record', minWidth: 170, type: 'boolean',
            renderCell: (cellValues) => {
                if (cellValues.row.isSchoolRecord) {
                    if (cellValues.row.requestStatus === 1) {
                        return ('Y (In Progress)')
                    }
                    return ('Y')
                }
                else {
                    return (<Switch
                        //disabled={!currentUser.isSuperAdmin}
                        checked={cellValues.row.isSchoolRecord}
                        onClick={(event) => {
                            handleSwitchChange(cellValues, cellValues.row.id, accessToken, showSuccess, showError);
                        }}

                        name="schoolRecord"

                    />)
                }
            }
        },
        { field: 'name', headerName: 'Application Name', minWidth: 100, maxWidth: 300, flex: 1 },
        { field: 'vendorName', headerName: 'Vendor', minWidth: 130, maxWidth: 200, flex: 1 },
        {
            field: 'url', headerName: 'URL', minWidth: 150, flex: 1,
            renderCell: (cellValues) => {
                var fullUrl;
                if (cellValues.row.url !== null && cellValues.row.url.startsWith('www')) {
                    fullUrl = 'http://' + cellValues.row.url;
                } else {
                    fullUrl = cellValues.row.url;
                }
                return (<a target="_blank" rel="noreferrer" href={fullUrl}>{cellValues.row.url}</a>)
            }
        },
        { field: 'description', headerName: 'Description', minWidth: 170, flex: 1, hide: true },
        {
            field: 'expired', headerName: 'Expired', minWidth: 27, flex: 1, hide: true, type: 'boolean'
        },
        { field: "approvalTotals", headerName: 'Institutions Approved', minWidth: 150, sortable: false, hide: false, },
        { field: "cloudHosted", headerName: 'Cloud Hosted', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "cloudProvider", headerName: 'Cloud Provider', minWidth: 150, sortable: false, hide: true, },
        { field: "cloudProviderOther", headerName: 'Cloud Provider', minWidth: 150, sortable: false, hide: true, },
        { field: "startDate", headerName: 'Start Date', minWidth: 150, sortable: false, hide: true, },
        { field: "endDate", headerName: 'End Date', minWidth: 150, sortable: false, hide: true, },
        { field: "itOwnerName", headerName: 'IT Owner', minWidth: 150, sortable: false, hide: true, },
        {
            field: "collectionModesSelected", headerName: 'Collection Mode', minWidth: 150, sortable: false, hide: true,
            renderCell: (cellValues) => {
                //check if null

                if (cellValues.row.collectionModesSelected === null || cellValues.row.collectionModesSelected.length === 0) {
                    return ('');
                }
                return (cellValues.row.collectionModesSelected.join('; '));
            },
            valueGetter: (params) => {
                if (params.row.collectionModesSelected === null || params.row.collectionModesSelected.length === 0) {
                    return ('');
                }
                return (params.row.collectionModesSelected.join(', '));
            }
        },
        { field: "gradesSelectedNames", headerName: 'Applicable Grades', minWidth: 150, sortable: false, hide: true, },
        { field: "areaOfUseSelected", headerName: 'Department of Responsibility', minWidth: 150, sortable: false, hide: true, },
        { field: "generalApplicationNotes", headerName: 'General Application Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "studentInfoSelectedNames", headerName: 'Student Information', minWidth: 150, sortable: false, hide: true, },
        { field: "employeeInfoSelectedNames", headerName: 'Employee Information', minWidth: 150, sortable: false, hide: true, },
        { field: "parentInfoSelectedNames", headerName: 'Parent/Guardian Information', minWidth: 150, sortable: false, hide: true, },
        { field: "alumniInfoSelectedNames", headerName: 'Alumni Information', minWidth: 150, sortable: false, hide: true, },
        { field: "volunteerInfoSelected", headerName: 'Volunteer Information', minWidth: 150, sortable: false, hide: true, },
        { field: "other", headerName: 'Other', minWidth: 150, sortable: false, hide: true, },
        { field: "dataCollectionNotes", headerName: 'Data Collection Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyNotification", headerName: 'Privacy Notification', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyTraining", headerName: 'Privacy Training', minWidth: 150, sortable: false, hide: true, },
        { field: "subcontractors", headerName: 'Subcontractors', minWidth: 150, sortable: false, hide: true, },
        { field: "subcontractorDataProtection", headerName: 'Subcontractors Data Protection', minWidth: 150, sortable: false, hide: true, },
        { field: "auditFrequencySelectedName", headerName: 'Audit Frequency', minWidth: 150, sortable: false, hide: true, },
        { field: "lastAuditDate", headerName: 'Last Audit Date', minWidth: 150, sortable: false, hide: true, },
        { field: "securityBreachPlan", headerName: 'Security Breach Plan', minWidth: 150, sortable: false, hide: true, },
        { field: "securityBreachInt", headerName: 'Security Breach', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "securityBreachDescription", headerName: 'Security Breach Description', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyPracticeReview", headerName: 'Privacy Practice Review', minWidth: 150, sortable: false, hide: true, },
        { field: "vendorSaleAssurance", headerName: 'Vendor Sales Assurance', minWidth: 150, sortable: false, hide: true, },
        { field: "dataProtectionNotes", headerName: 'Data Protection Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "dataBackup", headerName: 'Data Backup', minWidth: 150, sortable: false, hide: true, },
        { field: "lossProtection", headerName: 'Data Loss Protection', minWidth: 150, sortable: false, hide: true, },
        { field: "dataSinglePurpose", headerName: 'Data Single Purpose', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "dataRetentionPolicy", headerName: 'Data Retention Policy', minWidth: 150, sortable: false, hide: true, },
        { field: "dataRetentionLength", headerName: 'Data Retention Length', minWidth: 150, sortable: false, hide: true, },
        { field: "dataAfterDiscontinuing", headerName: 'Data Discontinuance', minWidth: 150, sortable: false, hide: true, },
        { field: "dataHandlingNotes", headerName: 'Data Handling Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "gDPRCompliant", headerName: 'GDPR Compliant', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "internetPIPublished", headerName: 'Personal Info Published', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "complianceNotes", headerName: 'ComplianceNotes', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "dataBreachCompliant", headerName: 'Data Breach Compliant', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "approved", headerName: 'Approved', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "notApproved", headerName: 'Not Approved', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "notApprovedReason", headerName: 'Not Approved Reason', minWidth: 150, sortable: false, hide: true, },
        {
            field: "approvalDate", headerName: 'Approval Date', minWidth: 150, sortable: false, hide: false,
            valueFormatter: (params) => params.value ? moment(params?.value).format("DD/MM/YYYY") : ''
        },
        { field: "approverName", headerName: 'Approver Name', minWidth: 150, sortable: false, hide: true, },
        { field: "hasExternalLLMs", headerName: 'Has External LLMs', minWidth: 150, sortable: false, hide: true, },
        { field: "llmProviders", headerName: 'LLM Providers', minWidth: 150, sortable: false, hide: true, },
        { field: "llmTraining", headerName: 'LLM Training', minWidth: 150, sortable: false, hide: true, },
        { field: "llmdDataShared", headerName: 'LLM Data Shared', minWidth: 150, sortable: false, hide: true, },
        { field: "llmUnder18Treatment", headerName: 'LLM Under 18 Treatment', minWidth: 150, sortable: false, hide: true, },
        { field: "llmRestrict", headerName: 'LLM Restrict', minWidth: 150, sortable: false, hide: true, },

    ];

    const randomNumber = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };


    let idCounter = 0;
    const createRandomRow = () => {
        idCounter += 1;
        return { id: idCounter, username: 'user' + idCounter, age: randomNumber(10, 80) };
    };

    const randomUserName = () => {
        return 'user ' + randomNumber(100, 1000);
    };




    const [refetch, setRefetch] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [rows, setRows] = React.useState(() => [
        createRandomRow(),
        createRandomRow(),
        createRandomRow(),
        createRandomRow(),
    ]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                
                const accessToken = localStorage.getItem("userToken");
                var response = await fetch('pia?userInfo=' + localStorage.getItem("userEmail"), {
                    method: 'GET',
                    withCredentials: true,
                    credentials: 'include',
                    headers: {
                        'Authorization': accessToken,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = await response.json();
                setreturnData(json);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);

            }
        };

        fetchData();
    }, [refetch]);

    if (returnData !== null) {
        vendorsToDisplay = returnData.vendorNames;
        itOwners = returnData.itOwnerNames;
        //collectionModes = returnData[0].collectionModeNames;
        grades = returnData.gradeList;
        studentItems = returnData.studentInfoList;
        staffItems = returnData.staffInfoList;
        parentItems = returnData.parentInfoList;
        alumniItems = returnData.alumniInfoList;
        volunteerItems = returnData.volunteerInfoList;
        areaOfUseItems = returnData.areaOfUseList;
        auditFrequencyList = returnData.auditFrequencyList;
        dataLocationItems = returnData.dataLocationList;
        cloudProviderItems = returnData.cloudProviderList;
        collectionModeItems = returnData.collectionModeList;
        approverList = returnData.approverList;
    }
    const titleBoxBackgroundColour = '#1976d21a';
    //button group setup
    const buttonGroupOptions = ['Institutional PIAs', 'Master PIAs', 'All PIAs'];

    if (loading) {
        return <DarkBackgroundDiv >
            <LoadingOverlay
                active={true}

                spinner={true}
                text="Loading..."
            >
            </LoadingOverlay>
        </DarkBackgroundDiv>;
    }


    if (error) {
        return <div>Error: {error.message}</div>;
    }

    console.log(returnData);


    const handleUpdateRow = () => {
     
        returnData.applications[0].name = randomUserName();
        setRefetch(!refetch);
        if (rows.length === 0) {
            return;
        }
        setRows((prevRows) => {
            const rowToUpdateIndex = randomNumber(0, rows.length - 1);

            return prevRows.map((row, index) =>
                index === rowToUpdateIndex ? { ...row, username: randomUserName() } : row,
            );
        });
    };

    const handleUpdateAllRows = () => {
        setRows(rows.map((row) => ({ ...row, username: randomUserName() })));
    };

    const handleDeleteRow = () => {
        if (rows.length === 0) {
            return;
        }
        setRows((prevRows) => {
            const rowToDeleteIndex = randomNumber(0, prevRows.length - 1);
            return [
                ...rows.slice(0, rowToDeleteIndex),
                ...rows.slice(rowToDeleteIndex + 1),
            ];
        });
    };

    const handleAddRow = () => {
        setRows((prevRows) => [...prevRows, createRandomRow()]);
    };
    const handleCancel = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        setOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    const handleDelete = () => {
        var data = { id: deleteId, accessToken: accessToken };

        saveApp(data, 'Delete', showError, showSuccess, null, setIsLoading);
        setDeleteOpen(false);
    };
    const closeSuccess = () => {
        setSuccessOpen(false);
    };
    const closeError = () => {
        setErrorOpen(false);
    };

    const handleAuditFrequencyChange = (e) => {

        if (e.target.value === -1) {
            setotherAuditShow(true);
            setValue('auditFrequencyId', e.target.value, { shouldValidate: true });
        }
        else {
            setotherAuditShow(false);
            setValue('auditFrequencyId', e.target.value, { shouldValidate: false }, { required: false });
        }
    }
    const handleCloudProviderChange = (event, cloudProviderOtherValue) => {

        setValue('cloudProviderId', event.target.value, { shouldValidate: true });
        setCloudProviderOtherShow(event.target.value === cloudProviderOtherValue);
    }

    const handleApprovedChange = (event, approveIsChecked) => {

        //turn off not approved and clear approver if checking
        if (event.target.checked) {
            setnotApproved(false, setapproved(true));
            setValue('approverId', '');
        }
        else {
            setapproved(false);
        }
    };

    const handleNotApprovedChange = (event) => {
        if (event.target.checked) {
            setapproved(false, setnotApproved(true));
            setValue('notApprovedReason', '');
        }
        else {
            setnotApproved(false);
        }
    };
    return (
        <Fragment>
        <div>
        <Collapse in={successOpen}  >
             <Stack spacing={2}>
                 <Alert severity="success" onClose={() => closeSuccess()}>{successMessage}</Alert>
             </Stack>
         </Collapse>
         <Collapse in={errorOpen}  >
             <Stack spacing={2}>
                 <Alert severity="error" onClose={() => closeError()}>An error occured</Alert>
             </Stack>
         </Collapse>
        </div>

        <Box sx={{ width: '100%' }}>
            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >

                <Grid container spacing={1}>

                    <Grid item xs={1} border={0}>
                        <Typography variant="h3" component="h2">
                            PIAs
                        </Typography>
                    </Grid>
                    <Grid style={{ paddingTop: '25px' }} item xs={2.2} border={0}>
                        <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button" >
                            <Button onClick={handlebgClick}>{buttonGroupOptions[selectedIndex]}</Button>
                            <Button
                                size="small"
                                aria-controls={bgOpen ? 'split-button-menu' : undefined}
                                aria-expanded={bgOpen ? 'true' : undefined}
                                aria-label="select merge strategy"
                                aria-haspopup="menu"
                                onClick={handlebgToggle}
                            >
                                <ArrowDropDownIcon />
                            </Button>
                        </ButtonGroup>

                        <Popper
                            sx={{
                                zIndex: 1,
                            }}
                            open={bgOpen}
                            anchorEl={anchorRef.current}
                            role={undefined}
                            transition
                            disablePortal
                        >
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin:
                                            placement === 'bottom' ? 'center top' : 'center bottom',
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList id="split-button-menu" autoFocusItem>
                                                {buttonGroupOptions.map((option, index) => (
                                                    <MenuItem
                                                        key={option}
                                                        //disabled={index === 2}
                                                        selected={index === selectedIndex}
                                                        onClick={(event) => handleMenuItemClick(event, index)}
                                                    >
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </Grid>
                    <Grid item xs={7.8} border={0}>
                        <TextField
                            // disabled={!currentUser.isSuperAdmin}
                            style={{ marginTop: '0px' }}
                            id="nameFilter"
                            name="url"
                            label="Begin Typing to Filter by Application Name"
                            fullWidth
                            margin="dense"
                            onChange={(e) => setFilterText(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={1} style={{ paddingTop: '25px' }}>
                        <Button variant="outlined" onClick={addApplication}>Add PIA</Button>
                    </Grid>
                </Grid>


            </Box>
            {/* <Stack direction="row" spacing={1}>
                <Button size="small" onClick={handleUpdateRow}>
                    Update a row
                </Button>
                <Button size="small" onClick={handleUpdateAllRows}>
                    Update all rows
                </Button>
                <Button size="small" onClick={handleDeleteRow}>
                    Delete a row
                </Button>
                <Button size="small" onClick={handleAddRow}>
                    Add a row
                </Button>
            </Stack> */}
            {/* <Box sx={{ height: 400, mt: 1 }}>
                <DataGrid rows={rows} columns={columns1} />
            </Box> */}
            <div style={{ height: '70vh', width: '100%' }}>
                <DataGrid
                    columns={columns}
                    rows={returnData.applications}
                    initialState={initialGridState}
                    filterModel={{
                        items: filterItem,
                    }}
                    rowsPerPageOptions={[25, 50, 1000]}

                    components={{
                        Toolbar: CustomToolbar,
                        //Footer: CustomFooter
                    }}

                />
            </div>
            <Dialog open={open && !loading} onClose={handleCancel}
                fullWidth

                maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}

            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} PIA
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                    {!isSchoolRecord && !currentUser.isSuperAdmin && (

                        <Typography variant="inherit" sx={{ fontSize: 14, paddingLeft: 2, color: "red" }} display='inline'>
                            This is a Master Record and cannot be modified
                        </Typography>
                    )}

                </DialogTitle>
                <DialogContent
                    style={{ padding: '2px 30px' }}>
                    <div>

                    </div>
                    <Collapse in={successDialogOpen}  >
                        <Stack spacing={2}>
                            <Alert severity="success" onClose={() => closeSuccess()}>{successMessage}</Alert>
                        </Stack>
                    </Collapse>
                    <Collapse in={errorDialogOpen}  >
                        <Stack spacing={2}>
                            <Alert severity="error" onClose={() => closeError()}>An error occured</Alert>
                        </Stack>
                    </Collapse>
                    {/* <DialogContentText>
                          </DialogContentText> */}
                    <form id='mainForm'>

                        <Grid item xs={12} sm={12}>
                            <TextField
                                required
                                id="id"
                                name="id"
                                label="ID"
                                fullWidth
                                hidden
                                margin="dense"
                                {...register('id')}

                            />

                        </Grid>
                        <Box px={1} py={0}>

                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setGeneralOpen(!generalOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }} >
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        General Application Information
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={generalOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    {/* 
                                    <Box px={3} py={2}>
                                    <Paper variant="outlined" > */}
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <CustomDisableInput
                                                disabled={!currentUser.isSuperAdmin && !isAdding}
                                                required
                                                id="name"
                                                name="name"
                                                label="Application Name"
                                                fullWidth
                                                margin="dense"
                                                {...register('name')}
                                                error={errors.name ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.name?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7} sm={7} md={7}>
                                            <TextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                //focused
                                                required
                                                id="url"
                                                name="url"
                                                label="Application URL"
                                                fullWidth
                                                margin="dense"
                                                {...register('url')}
                                                error={errors.url ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.url?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "38px", paddingRight: 0, paddingLeft: "10px" }}>

                                            <Button
                                                //size={"small"} 
                                                sx={{ m: 0, p: 0, minWidth: .6 }}
                                                variant="outlined"
                                                //underline="hover"
                                                //color="inherit"
                                                //href={getValues('evalUrl')}

                                                href={getProperUrl(getValues('url'))}
                                                target="_blank"
                                            >
                                                Go
                                            </Button>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <FormControl sx={{ m: 0, minWidth: 250, maxWidth: 300 }}
                                                required
                                            >
                                                <InputLabel>Vendor</InputLabel>

                                                <Controller

                                                    required
                                                    name="vendorId"
                                                    control={control}
                                                    defaultValue=""
                                                    // {...register("vendor")}
                                                    render={({ field: { onChange, value } }) => (
                                                        <CustomDisableInputSelect
                                                            disabled={!currentUser.isSuperAdmin && !isAdding}
                                                            required
                                                            defaultValue={0}
                                                            value={value}
                                                            label="Vendor"
                                                            onChange={(e) => setValue('vendorId', e.target.value, { shouldValidate: true })}
                                                        >
                                                            {vendorsToDisplay.map((vendor, index) => <MenuItem key={index} value={vendor.id}>{vendor.name}</MenuItem>)}

                                                        </CustomDisableInputSelect>
                                                    )}
                                                />
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.vendorId?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                            <FormGroup>
                                                <FormControlLabel control={<Checkbox checked={vendorConfirmed} onChange={handleVendorConfirmedChange} />} label="Vendor Confirmed" />

                                            </FormGroup>

                                        </Grid>
                                        <Grid item xs={2.9} sm={2.9} md={2.9}>
                                            <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>Common Sense Media:</InputLabel>
                                        </Grid>
                                        {/* <Grid item xs={5} sm={5} container={true} >
            
                                    <InputLabel sx={{ paddingTop: 1.5, paddingRight: 1, paddingLeft: 1 }}>Common Sense Media Eval:</InputLabel>
                                    <TextField
                                      //label="Common Sense Media Evaluation"
                                      style={{ maxWidth: '100px' }}
                                      type="number"
            
            
                                      //sx={{ m: 1, width: '25ch' }}
                                      InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        // shrink: true
                                      }}
                                      id="commonSenseRating"
                                      name="commonSenseRating"
            
                                      {...register('commonSenseRating')}
                                      error={errors.commonSenseRating ? true : false}
                                    />
            
                                    <Typography variant="inherit" color="error.main">
                                      {errors.commonSenseRating?.message}
                                    </Typography>
            
                                  </Grid> */}
                                        <Grid item xs={3.9} sm={3.9} md={3.9} >

                                            <FormControl>
                                                {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"

                                                >
                                                    <ToggleButtonGroup value={commonSense} exclusive onChange={handleCommonSenseChange}>
                                                        <ToggleButton value={2} selectedColor="green">
                                                            Pass
                                                        </ToggleButton>
                                                        <ToggleButton value={1} selectedColor="orange">
                                                            Warning
                                                        </ToggleButton>
                                                        <ToggleButton value={0} selectedColor="Red">
                                                            Fail
                                                        </ToggleButton>
                                                        <ToggleButton value={4} selectedColor="Grey">
                                                            N/A
                                                        </ToggleButton>

                                                    </ToggleButtonGroup>
                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.commonSense?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={4.5} sm={4.5} md={4.5} >
                                            <TextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                //focused
                                                //required
                                                // InputProps={{
                                                //   endAdornment: (
                                                //     <Link to={getValues('evalUrl')}>{getValues('evalUrl')}</Link>
                                                //   ),
                                                // }}
                                                id="url"
                                                name="url"
                                                label="CSM Software Evaluation URL"
                                                //onChange={(e) => handleEvalUrlChange(e.target.value)}
                                                //onChange={(e) => alert('changing')}
                                                //onChange={(e) => setFilterText(e.target.value)}

                                                fullWidth
                                                //margin="dense"
                                                {...register('evalUrl')}
                                                error={errors.evalUrl ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.evalUrl?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={.7} sm={.7} md={.7} style={{ paddingTop: "30px", paddingRight: 0, paddingLeft: "10px" }}>

                                            <Button
                                                //size={"small"} 
                                                sx={{ m: 0, p: 0, minWidth: 1 }}
                                                variant="outlined"
                                                //underline="hover"
                                                //color="inherit"
                                                //href={getValues('evalUrl')}

                                                href={getProperUrl(getValues('evalUrl'))}
                                                target="_blank"
                                            >
                                                Go
                                            </Button>
                                        </Grid>

                                        <Grid item xs={2.3} sm={2.3} md={2.3}>
                                            <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>Compliance GDPR:</InputLabel>
                                        </Grid>
                                        <Grid item xs={5} sm={5} md={5} >

                                            <FormControl>
                                                {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                >
                                                    <ToggleButtonGroup value={gDPRComplianceLevel} exclusive onChange={handleGDPRChange}>
                                                        <ToggleButton value={2} selectedColor="green">
                                                            Certified
                                                        </ToggleButton>
                                                        <ToggleButton value={1} selectedColor="green">
                                                            Meets Criteria
                                                        </ToggleButton>
                                                        <ToggleButton value={0} selectedColor="Red">
                                                            Unkn
                                                        </ToggleButton>

                                                    </ToggleButtonGroup>
                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.commonSense?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={1} sm={1.1} md={1.1} >
                                            <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>COPPA:</InputLabel>
                                        </Grid>
                                        <Grid item xs={3} sm={3} md={3}>

                                            <FormControl>
                                                {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                >
                                                    <ToggleButtonGroup value={coppa} exclusive onChange={handleCoppaChange}>
                                                        <ToggleButton value={2} selectedColor="green">
                                                            Yes
                                                        </ToggleButton>
                                                        <ToggleButton value={1} selectedColor="orange">
                                                            Unkn
                                                        </ToggleButton>
                                                        <ToggleButton value={0} selectedColor="Red">
                                                            No
                                                        </ToggleButton>
                                                        <ToggleButton value={3} selectedColor="Grey">
                                                            N/A
                                                        </ToggleButton>

                                                    </ToggleButtonGroup>
                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.commonSense?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={11.5} sm={11.5} md={11.5} paddingRight={0}>
                                            <SelfSizingTextField
                                                required
                                                initialValue={getValues('description')}
                                                maxSize={1000}
                                                errors={errors.description}
                                                register={register}
                                                name="description"
                                                id="description"
                                                label="Description of Application"
                                                placeholder="Description of Application"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={0.5} sm={0.5} md={0.5} paddingLeft={0.5} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Description of the application and why private data is needed.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={4} sm={4} md={4}>
                                            <FormControl>
                                                <FormLabel id="demo-radio-buttons-group-label">Cloud Hosted *</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                    {...register('cloudHosted')}
                                                    onChange={(e) => {

                                                        handleBooleanRadioButtonChange(e, setCloudHosted);

                                                    }}
                                                >
                                                    {/* <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && !cloudHosted} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                                          <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && cloudHosted} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" /> */}
                                                    <FormControlLabel {...register('cloudHosted')} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('cloudHosted')} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.cloudHosted?.message}
                                            </Typography>

                                        </Grid>
                                        {/* <Grid item xs={4} sm={4} md={4}>
                                      <FormControlLabel control={<Switch
                                        checked={cloudHosted}
                                        onChange={(e) => handleCloudHostedChange(e, setCloudHosted)}
                                        name="cloudHosted"
            
                                      />}
                                        label="Cloud Hosted"
                                        {...register('cloudHosted')}
                                      />
            
                                    </Grid> */}
                                        {cloudHosted &&
                                            <Grid item xs={4} sm={4}>
                                                <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                                                    <InputLabel sx={{ paddingTop: 1.5 }}>Cloud Provider</InputLabel>
                                                    <Controller
                                                        name="cloudProviderId"
                                                        control={control}

                                                        render={({ field: { onChange, value } }) => (
                                                            <Select id='cloudProviderId'
                                                                value={value}
                                                                label="Cloud Provider"
                                                                onChange={e => handleCloudProviderChange(e, cloudProviderOtherValue)}
                                                            >
                                                                {cloudProviderItems.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                                                            </Select>
                                                        )} />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.cloudProviderId?.message}
                                                </Typography>
                                            </Grid>
                                        }

                                        {cloudHosted && cloudProviderOtherShow &&
                                            <Fragment>
                                                <Grid item xs={4} sm={4}>
                                                    <FormControl sx={{ m: 0, minWidth: 200 }}>
                                                        <TextField
                                                            // disabled={!currentUser.isSuperAdmin}
                                                            id="cloudProvider"
                                                            name="cloudProvider"
                                                            label="Other Cloud Provider"
                                                            fullWidth
                                                            margin="dense"
                                                            {...register('cloudProvider')}
                                                            error={errors.cloudProvider ? true : false}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.cloudProvider?.message}
                                                    </Typography>


                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="What cloud service is hosting the application? ">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>
                                            </Fragment>
                                        }
                                        <Grid item xs={12} sm={12}></Grid>
                                        <Grid item xs={6} sm={4}  >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id="startDate"
                                                    name="startDate"
                                                    label="Date Started"
                                                    {...register('startDate')}
                                                    value={startDate}
                                                    onChange={(newValue) => {
                                                        setStartDate(newValue);
                                                        setValue("startDate", newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />

                                            </LocalizationProvider>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.startDate?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="The date you started using the application.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6} sm={4}  >
                                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id="endDate"
                                                    name="endDate"
                                                    label="Date Ended"
                                                    {...register('endDate')}
                                                    value={endDate}
                                                    onChange={(newValue) => {
                                                        setEndDate(newValue);
                                                        setValue("endDate", newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.endDate?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="The date you stopped using the application - needed for historical reporting.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>



                                        <Grid item xs={12} />
                                        {!(!currentUser.isSuperAdmin || true) &&

                                            <Grid item xs={6} sm={6}>
                                                <FormControl sx={{ m: 0, minWidth: 200 }}>
                                                    <InputLabel>Institution Point of Contact </InputLabel>
                                                    <Controller
                                                        name="itOwnerId"
                                                        control={control}
                                                        defaultValue=""
                                                        // {...register("vendor")}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Select
                                                                defaultValue={0}
                                                                value={value}
                                                                label="Institution Point of Contact"
                                                                onChange={(e) => setValue('itOwnerId', e.target.value, { shouldValidate: true })}
                                                            >
                                                                {itOwners.map((owner, index) => <MenuItem key={index} value={owner.id}>{owner.name}</MenuItem>)}

                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.itOwner?.message}
                                                </Typography>
                                            </Grid>
                                        }
                                        <Grid item xs={5} sm={5}>
                                            <FormControl sx={{ m: 0, minWidth: 200 }}>
                                                {/* <InputLabel>Collection Mode </InputLabel>
                                       <Controller
                                          name="collectionModeId"
                                          control={control}
                                          defaultValue=""
                                          // {...register("vendor")}
                                          render={({ field: { onChange, value } }) => (
                                            <Select
                                              defaultValue={0}
                                              value={value}
                                              label="Collection Mode"
                                              onChange={(e) => setValue('collectionModeId', e.target.value, { shouldValidate: true })}
                                            >
                                              {collectionModes.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}
            
                                            </Select>
                                          )}
                                        /> */}
                                                {/*
                                      </FormControl> */}
                                                {/* <Typography variant="inherit" color="error.main">
                                        {errors.collectionModeId?.message}
                                      </Typography> */}
                                                <MultiSelectWithChips
                                                    label="Collection Mode"
                                                    name="collectionModesSelected"
                                                    control={control}
                                                    value={collectionModesSelected}
                                                    infoSelected={collectionModesSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setCollectionModesSelected}
                                                    onChange={HandleChange}
                                                    handleChipDelete={handleChipDelete}
                                                    errors={errors.collectionModesSelected}

                                                    items={collectionModeItems}
                                                >
                                                </MultiSelectWithChips>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="How is the student data transfered to the third party application?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        {collectionModesSelected.indexOf('Other') !== -1 && (
                                            <Grid item xs={6} sm={6} md={6} lg={6} >
                                                <FormControl sx={{ m: 0, minWidth: 400 }}>
                                                    <TextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        id="collectionModeOther"
                                                        name="collectionModeOther"
                                                        label="Other Collection Mode"
                                                        fullWidth
                                                        margin="dense"
                                                        {...register('collectionModeOther')}
                                                        error={errors.collectionModeOther ? true : false}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.collectionModeOther?.message}
                                                </Typography>
                                            </Grid>
                                        )}
                                        <Grid item xs={5} sm={5}>
                                            <MultiSelectWithChips
                                                label="Applicable Grades"
                                                name="gradesSelected"
                                                control={control}
                                                value={gradesSelected}
                                                infoSelected={gradesSelected}
                                                infoNASelected={gradesNASelected}
                                                setinfoSelected={setgradesSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.gradesSelected}

                                                items={grades}
                                            >
                                            </MultiSelectWithChips>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="What grade are using the application - important for reporting.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={5} sm={5}>
                                            <MultiSelectWithChips
                                                label="Department of Responsibility"
                                                name="areaOfUseSelected"
                                                control={control}
                                                value={areaOfUseSelected}
                                                infoSelected={areaOfUseSelected}
                                                //infoNASelected={studentInfoNASelected}
                                                setinfoSelected={setareaOfUseSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDeleteForApplicableDepts}
                                                errors={errors.areaOfUseItems}

                                                items={areaOfUseItems}
                                            >
                                            </MultiSelectWithChips>


                                            <Typography variant="inherit" color="error.main">
                                                {errors.areaOfUseSelected?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="What department(s) are using this software?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        {otherDepartmentsShow && (
                                            <Grid item xs={6} style={{ paddingTop: 25 }} >

                                                <TextField

                                                    // disabled={!currentUser.isSuperAdmin}
                                                    InputLabelProps={{ shrink: true }}
                                                    id="applicableDepartmentsOther"
                                                    name="applicableDepartmentsOther"
                                                    label="Other Applicable Departments"
                                                    fullWidth
                                                    placeholder="Other Applicable Departments"
                                                    {...register('applicableDepartmentsOther')}
                                                />

                                                <Typography variant="inherit" color="error.main">
                                                    {errors.applicableDepartmentsOther?.message}
                                                </Typography>

                                            </Grid>
                                        )}


                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('generalApplicationNotes')}
                                                maxSize={2000}
                                                errors={errors.generalApplicationNotes}
                                                register={register}
                                                name="generalApplicationNotes"
                                                id="generalApplicationNotes"
                                                label="General Application Notes"
                                                placeholder="General Application Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other general information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={4.5} sm={4.5} md={4.5} >
                                            <TextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                //focused
                                                //required
                                                // InputProps={{
                                                //   endAdornment: (
                                                //     <Link to={getValues('evalUrl')}>{getValues('evalUrl')}</Link>
                                                //   ),
                                                // }}
                                                id="url"
                                                name="url"
                                                label="Contract URL"
                                                //onChange={(e) => handleEvalUrlChange(e.target.value)}
                                                //onChange={(e) => alert('changing')}
                                                //onChange={(e) => setFilterText(e.target.value)}

                                                fullWidth
                                                //margin="dense"
                                                {...register('contractUrl')}
                                                error={errors.contractUrl ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.contractUrl?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={.7} sm={.7} md={.7} style={{ paddingTop: "30px", paddingRight: 0, paddingLeft: "10px" }}>

                                            <Button
                                                //size={"small"} 
                                                sx={{ m: 0, p: 0, minWidth: 1 }}
                                                variant="outlined"
                                                //underline="hover"
                                                //color="inherit"
                                                //href={getValues('evalUrl')}

                                                href={getProperUrl(getValues('contractUrl'))}
                                                target="_blank"
                                            >
                                                Go
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {/* </Paper>
                                    </Box>*/}
                                </Box>
                            </Collapse>

                            <Grid item xs={12} />
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataCollectionOpen(!dataCollectionOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Collection
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataCollectionOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>
                                </Grid>
                            </Box>
                            <Collapse in={dataCollectionOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>
                                        {/* <Grid item xs={12} /> */}
                                        <Grid item xs={5}>
                                            <MultiSelectWithChips
                                                label="Student Information"
                                                name="studentInfoSelected"
                                                control={control}
                                                value={studentInfoSelected}
                                                infoSelected={studentInfoSelected}
                                                infoNASelected={studentInfoNASelected}
                                                setinfoSelected={setstudentInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.studentInfoSelected}
                                                items={studentItems}
                                            >
                                            </MultiSelectWithChips>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Private student data fields that are sent to the 3rd party application. ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={5} >
                                            <MultiSelectWithChips
                                                label="Employee Information "
                                                name="staffInfoSelected"
                                                control={control}
                                                value={staffInfoSelected}
                                                infoSelected={staffInfoSelected}
                                                infoNASelected={staffInfoNASelected}
                                                setinfoSelected={setstaffInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.staffInfoSelected}
                                                items={staffItems}
                                            >
                                            </MultiSelectWithChips>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Private employee data fields that are sent to the 3rd party application. ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <MultiSelectWithChips
                                                label="Parent/Guardian Information"
                                                name="parentInfoSelected"
                                                control={control}
                                                value={parentInfoSelected}
                                                infoSelected={parentInfoSelected}
                                                infoNASelected={parentInfoNASelected}
                                                setinfoSelected={setparentInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.parentInfoSelected}
                                                items={parentItems}
                                            >
                                            </MultiSelectWithChips>

                                            <Typography variant="inherit" color="error.main">
                                                {errors.parentInfoSelected?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Private Parent/Guardian data fields that are sent to the 3rd party application.  ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <MultiSelectWithChips
                                                label="Alumni Information"
                                                name="alumniInfoSelected"
                                                control={control}
                                                value={alumniInfoSelected}
                                                infoSelected={alumniInfoSelected}
                                                infoNASelected={alumniInfoNASelected}
                                                setinfoSelected={setalumniInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.alumniInfoSelected}
                                                items={alumniItems}
                                            >
                                            </MultiSelectWithChips>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Private alumni data fields that are sent to the 3rd party application. ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <MultiSelectWithChips
                                                label="Volunteer Information"
                                                name="volunteerInfoSelected"
                                                control={control}
                                                value={volunteerInfoSelected}
                                                infoSelected={volunteerInfoSelected}
                                                infoNASelected={volunteerInfoNASelected}
                                                setinfoSelected={setVolunteerInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.volunteerInfoSelected}
                                                items={volunteerItems}
                                            >
                                            </MultiSelectWithChips>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Private volunteer data fields that are sent to the 3rd party application.  ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('other')}
                                                errors={errors.other}
                                                register={register}
                                                maxSize={2000}
                                                name="other"
                                                id="other"
                                                label="Other"
                                                placeholder="Cookies, other information collected etc."
                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Cookies, IP addresses, or anything else tracked by the application. ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataCollectionNotes')}
                                                maxSize={2000}
                                                errors={errors.dataCollectionNotes}
                                                register={register}
                                                name="dataCollectionNotes"
                                                id="dataCollectionNotes"
                                                label="Data Collection Notes"
                                                placeholder="Data Collection Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data collection information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>



                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataProtectionOpen(!dataProtectionOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Protection
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataProtectionOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={dataProtectionOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('privacyNotification')}
                                                errors={errors.privacyNotification}
                                                register={register}
                                                maxSize={1000}
                                                name="privacyNotification"
                                                id="privacyNotification"
                                                label="Privacy Notification"
                                                placeholder="How does the vendor notify customers of privacy policy changes?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="How does the vendor notify customers of a change in the data policy?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    inputFormat="MMM-YYYY"
                                                    views={['month', 'year']}
                                                    id="policyLastUpdated"
                                                    name="policyLastUpdated"
                                                    label="Privacy Policy Last Updated"
                                                    //{...register('policyLastUpdated')}
                                                    value={policyLastUpdated}

                                                    onChange={(newValue) => {
                                                     
                                                        setPolicyLastUpdated(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />
                                            </LocalizationProvider>

                                            <Typography variant="inherit" color="error.main">
                                                {errors.policyLastUpdated?.message}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('subcontractors')}
                                                errors={errors.subcontractors}
                                                register={register}
                                                maxSize={1000}
                                                name="subcontractors"
                                                id="subcontractors"
                                                label="Subcontractors"
                                                placeholder="List subcontractors who have access to data"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="The list (or a link to the list) of the vetted subcontractors.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12}>

                                            <FormControl>
                                                <FormLabel id="demo-radio-buttons-group-label">Has the organization experienced a privacy breach in the past?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                    //{...register('subcontractorDataProtection')}
                                                    onChange={(e) => handleSecurityBreachChange(e, setSecurityBreachInt)}
                                                >
                                                    <FormControlLabel {...register('securityBreachInt')} key='1' value={'1'} checked={securityBreachInt == '1'} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('securityBreachInt')} key='0' value={'0'} checked={securityBreachInt == '0'} control={<Radio />} label="No" />
                                                    <FormControlLabel {...register('securityBreachInt')} key='-1' value={'-1'} checked={securityBreachInt == '-1'} control={<Radio />} label="Unknown" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.securityBreachInt?.message}
                                            </Typography>
                                        </Grid>

                                        {securityBreachInt == '1' && (<Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('securityBreachDescription')}
                                                errors={errors.securityBreachDescription}
                                                register={register}
                                                maxSize={1000}
                                                name="securityBreachDescription"
                                                id="securityBreachDescription"
                                                label="Security Breach Description"
                                                placeholder="If yes, please explain the incident"
                                            ></SelfSizingTextField>
                                        </Grid>)}

                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('privacyPracticeReview')}
                                                errors={errors.privacyPracticeReview}
                                                register={register}
                                                maxSize={1000}
                                                name="privacyPracticeReview"
                                                id="privacyPracticeReview"
                                                label="Privacy Practice Review"
                                                placeholder="How often does the vendor review its privacy practices?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="How often does the vendor review its privacy practices?.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>


                                        <Grid item xs={11}>
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('vendorSaleAssurance')}
                                                errors={errors.vendorSaleAssurance}
                                                register={register}
                                                maxSize={1000}
                                                name="vendorSaleAssurance"
                                                id="vendorSaleAssurance"
                                                label="Vendor Sale Assurance"
                                                placeholder="Is there an assurance that the privacy policy will stay in place until renewal if the vendor is sold?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Is there an assurance that the privacy policy for the school’s data will stay in place until renewal if the vendor is sold?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataProtectionNotes')}
                                                maxSize={2000}
                                                errors={errors.dataProtectionNotes}
                                                register={register}
                                                name="dataProtectionNotes"
                                                id="dataProtectionNotes"
                                                label="Data Protection Notes"
                                                placeholder="Data Protection Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data protection information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataHandlingOpen(!dataHandlingOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Handling
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataHandlingOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>

                            <Collapse in={dataHandlingOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>

                                        <Grid item xs={11}>

                                            <FormControl>
                                                <FormLabel id="demo-radio-buttons-group-label">Vendor ensures that the data is not used for anything other than the stated purpose &nbsp;</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                    //{...register('subcontractorDataProtection')}
                                                    onChange={(e) => handleBooleanRadioButtonChange(e, setDataSinglePurpose)}
                                                >

                                                    {/* <FormControlLabel {...register('dataSinglePurpose')} disabled={!currentUser.isSuperAdmin && !dataSinglePurpose} key='1' value={'1'} checked={dataSinglePurpose} control={<Radio />} label="Yes" />
                                          <FormControlLabel {...register('dataSinglePurpose')} disabled={!currentUser.isSuperAdmin && dataSinglePurpose} key='0' value={'0'} checked={dataSinglePurpose === false} control={<Radio />} label="No" /> */}
                                                    <FormControlLabel {...register('dataSinglePurpose')} key='1' value={'1'} checked={dataSinglePurpose} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('dataSinglePurpose')} key='0' value={'0'} checked={dataSinglePurpose === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Tooltip paddingLeft={"10px"} title="The vendor assures that the data is being used for anything that is not descrived in the privacy agreement, including targetted advertising or that the data is being sold">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                            <Typography variant="inherit" color="error.main" >
                                                {errors.dataSinglePurpose?.message}
                                            </Typography>
                                            {/* <FormControlLabel control={<Switch
                                        checked={dataSinglePurpose ?? false}
                                        onChange={handleDataSinglePurposeChange}
                                      />}
                                        label="Vendor ensures that the data is not used for anything other than the stated purpose"
                                        {...register('dataSinglePurpose')}
                                      /> */}
                                        </Grid>


                                        <Grid item xs={5} sm={5}>
                                            <MultiSelectWithChips
                                                label="Where does the data reside?"
                                                name="dataLocationSelected"
                                                control={control}
                                                value={dataLocationSelected}
                                                infoSelected={dataLocationSelected}
                                                //infoNASelected={studentInfoNASelected}
                                                setinfoSelected={setdataLocationSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.dataLocationSelected}

                                                items={dataLocationItems}
                                            >
                                            </MultiSelectWithChips>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                            <Tooltip title="Where is the data housed - it could be multiple countries.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        {dataLocationSelected.indexOf('Other') !== -1 && (
                                            <Grid item xs={6} sm={6} md={6} style={{ paddingTop: 25 }} >

                                                <TextField


                                                    InputLabelProps={{ shrink: true }}
                                                    id="dataLocationOther"
                                                    name="dataLocationOther"
                                                    label="Other Data Location"
                                                    fullWidth
                                                    placeholder="Other Data Location"
                                                    {...register('dataLocationOther')}
                                                />

                                                <Typography variant="inherit" color="error.main">
                                                    {errors.dataLocationOther?.message}
                                                </Typography>

                                            </Grid>


                                        )}
                                        {/* <FormControl sx={{ m: 0, width: 250 }}>
                                      <InputLabel> Where does the data reside? </InputLabel>
                                      <Controller
                                        name="dataLocationSelected"
                                        control={control}
                                        defaultValue=""
                                        render={({ field: { onChange, value } }) => (
                                          <Select
                                            // disabled={!currentUser.isSuperAdmin}
                                            multiple
                                            MenuProps={MenuProps}
                                            name="dataLocationSelected"
                                            value={dataLocationSelected}
                                            label="Where does the data reside?"
                                            input={<OutlinedInput label="Where does the data reside?" />}
                                            onChange={HandleChange}
                                            renderValue={(selected) => selected.join(',')}
                                          >
                                            {dataLocationItems.map((item) => (
                                              <MenuItem value={item} key={item} >
                                                <Switch checked={dataLocationSelected.indexOf(item) > -1} />
                                                {<ListItemText primary={item} />}
                                              </MenuItem>
                                            ))}
            
                                          </Select>
                                        )}
                                      />
                                    </FormControl>
                                    <Typography variant="inherit" color="error.main">
                                      {errors.dataLocationSelected?.message}
                                    </Typography>
                                  </Grid> */}
                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('dataRetentionPolicy')}
                                                errors={errors.dataRetentionPolicy}
                                                register={register}
                                                maxSize={1000}
                                                name="dataRetentionPolicy"
                                                id="dataRetentionPolicy"
                                                label="Data Retention Policy"
                                                placeholder="Describe the data retention policy for active and inactive accounts"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="What is the data retention policy for the country - for active accounts and for inactive accounts.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        {/* <Grid item xs={12} sm={12} md={12}>
                                    <SelfSizingTextField
                                      // disabled={!currentUser.isSuperAdmin}
                                      initialValue={getValues('dataRetentionLength')}
                                      errors={errors.dataRetentionLength}
                                      register={register}
                                      maxSize={1000}
                                      name="dataRetentionLength"
                                      id="dataRetentionLength"
                                      label="Data Retention Length"
                                      placeholder="How long is the data retained?"
                                    ></SelfSizingTextField>
                                  </Grid> */}

                                        <Grid item xs={11} >
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('dataAfterDiscontinuing')}
                                                errors={errors.dataAfterDiscontinuing}
                                                register={register}
                                                maxSize={2500}
                                                name="dataAfterDiscontinuing"
                                                id="dataAfterDiscontinuing"
                                                label="Data Discontinuance"
                                                placeholder="What happens to the data if relationship with the software vendor is discontinued."
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="How is private data removed from the application if the school is no longer a client?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={11} >

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataHandlingNotes')}
                                                maxSize={2000}
                                                errors={errors.dataHandlingNotes}
                                                register={register}
                                                name="dataHandlingNotes"
                                                id="dataHandlingNotes"
                                                label="Data Handling Notes"
                                                placeholder="Data Handling Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data handling information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setOtherOpen(!otherOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Compliance
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {otherOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={otherOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    {/* <Typography variant="inherit">
                                    Hover over items to show expanded information
                                  </Typography> */}

                                    <Grid container spacing={2}>
                                        <Grid item xs={6} sm={6} md={6}>

                                            <FormControl>
                                                <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                                                    <FormLabel id="gdpr-label">Software is GDPR Compliant</FormLabel>
                                                </Tooltip>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="gDPRCompliant"
                                                    {...register('gDPRCompliant')}
                                                    //onChange={handleGdprChange}
                                                    onChange={(e) => {

                                                        handleBooleanRadioButtonChange(e, setgDPRCompliant);

                                                    }}
                                                >

                                                    <FormControlLabel {...register('gDPRCompliant')} key='1' value={'1'} checked={gDPRCompliant} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('gDPRCompliant')} key='0' value={'0'} checked={gDPRCompliant === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>

                                        </Grid>



                                        {/* <Grid item xs={6} sm={6} md={6}>
                                      <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                                        <FormControlLabel control={<Switch
                                          // disabled={!currentUser.isSuperAdmin}
                                          checked={gDPRCompliant ?? false}
                                          onChange={handleGdprChange}
                                          name="gDPRCompliant"
            
                                        />}
                                          label="Software is compliant with GDPR"
                                          {...register('gDPRCompliant')}
                                        />
                                      </Tooltip>
            
                                    </Grid> */}
                                        {gDPRCompliant &&
                                            <Fragment>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <Typography variant="inherit" >
                                                        <p>
                                                            This software is GDPR compliant, which ensures that it meets various
                                                            essential criteria outlined in the privacy impact assessment. Being
                                                            GDPR compliant indicates that the software provider has implemented
                                                            several measures to protect the privacy and security of student data.
                                                        </p>
                                                        <p>
                                                            These measures include:
                                                        </p>
                                                        <p>
                                                            Privacy Training Plan: The software provider has a comprehensive
                                                            privacy training plan in place for its employees, ensuring they
                                                            understand the importance of data protection and privacy regulations.
                                                        </p>
                                                        <p>
                                                            Security Breach Plan: The software provider has established a robust
                                                            security breach plan to promptly detect, respond to, and mitigate any
                                                            potential data breaches or unauthorized access incidents.
                                                        </p>
                                                        <p>
                                                            Subcontractor Vetting: All subcontractors and third-party service
                                                            providers associated with the software have been thoroughly vetted to
                                                            ensure they adhere to stringent privacy standards.
                                                        </p>
                                                        <p>
                                                            Privacy Audit Cycle: The software provider follows a reasonable cycle
                                                            to conduct privacy audits, verifying that data protection practices
                                                            remain up to date and compliant with relevant regulations.
                                                        </p>
                                                        <p>
                                                            Backup and Storage Plan: The software provider maintains a sufficient
                                                            backup and storage plan to safeguard student data, ensuring its
                                                            availability and integrity.
                                                        </p>
                                                        <p>
                                                            Security Tools: The software incorporates various security tools, such
                                                            as Security Information and Event Management (SIEM), encrypted data
                                                            transit, and robust password complexity requirements, to protect
                                                            against unauthorized access and ensure data confidentiality.
                                                        </p>
                                                    </Typography>
                                                </Grid>
                                            </Fragment>
                                        }
                                        {!gDPRCompliant &&
                                            <Fragment>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <Typography variant="inherit" >
                                                        The Vendor only needs to fill these sections below if they are not GDPR compliant
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={11} >
                                                    <SelfSizingTextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        initialValue={getValues('privacyTraining')}
                                                        errors={errors.privacyTraining}
                                                        register={register}
                                                        maxSize={1000}
                                                        name="privacyTraining"
                                                        id="privacyTraining"
                                                        label="Privacy Training"
                                                        placeholder="How does the vendor ensure employees are trained to handle private data?"
                                                    ></SelfSizingTextField>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="How does the vendor ensure employees are trained to handle private data?">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>

                                                <Grid item xs={11}>
                                                    <SelfSizingTextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        initialValue={getValues('securityBreachPlan')}
                                                        errors={errors.securityBreachPlan}
                                                        register={register}
                                                        maxSize={2000}
                                                        name="securityBreachPlan"
                                                        id="securityBreachPlan"
                                                        label="Security Breach Plan"
                                                        placeholder="What is the security breach plan and what is the notification timeline?"
                                                    ></SelfSizingTextField>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="What is the security breach plan and what is the notification timeline?">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12}>

                                                    <FormControl>
                                                        <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data &nbsp;
                                                            <Tooltip title="Are all subcontractors outlined above required to protect UCC data in accordance with applicable privacy laws and privacy/security industry best practice?">
                                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                            </Tooltip>
                                                        </FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-radio-buttons-group-label"

                                                            name="radio-buttons-group"
                                                            //{...register('subcontractorDataProtection')}
                                                            onChange={(e) => handleSubcontractorRadioButtonChange(e, setSubcontractorDataProtection)}
                                                        >

                                                            {/* <FormControlLabel {...register('subcontractorDataProtection')} disabled={!currentUser.isSuperAdmin && !subcontractorDataProtection} key='1' value={'1'} checked={subcontractorDataProtection} control={<Radio />} label="Yes" />
                                                <FormControlLabel {...register('subcontractorDataProtection')} disabled={!currentUser.isSuperAdmin && subcontractorDataProtection} key='0' value={'0'} checked={subcontractorDataProtection === false} control={<Radio />} label="No" /> */}
                                                            <FormControlLabel {...register('subcontractorDataProtection')} key='1' value={'1'} checked={subcontractorDataProtection === '1'} control={<Radio />} label="Yes" />
                                                            <FormControlLabel {...register('subcontractorDataProtection')} key='0' value={'0'} checked={subcontractorDataProtection === '0'} control={<Radio />} label="No" />
                                                            <FormControlLabel {...register('subcontractorDataProtection')} key='2' value={'2'} checked={subcontractorDataProtection === '2'} control={<Radio />} label="N/A" />

                                                        </RadioGroup>

                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.subcontractorDataProtection?.message}
                                                    </Typography>

                                                </Grid>
                                                {/* <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Are all subcontractors outlined above required to protect personally identifiable data in accordance with applicable privacy laws and privacy/security industry best practice?">
                                          <FormControlLabel control={<Switch
                                            checked={subcontractorDataProtection ?? false}
                                            onChange={handleSubContractorChange}
                                          />}
                                            label="Subcontractors required to protect data"
                                            {...register('subcontractorDataProtection')}
                                          />
                                        </Tooltip> */}

                                                <Grid item xs={4} sm={4}>
                                                    <FormControl sx={{ m: 0, minWidth: 220 }}>
                                                        <InputLabel>Privacy Audit Frequency</InputLabel>
                                                        <Controller
                                                            name="auditFrequencyId"
                                                            control={control}
                                                            //defaultValue=""
                                                            // {...register("vendor")}
                                                            render={({ field: { onChange, value } }) => (
                                                                <Select
                                                                    // disabled={!currentUser.isSuperAdmin}
                                                                    defaultValue={0}
                                                                    value={value}
                                                                    label="Privacy Audit Frequency"
                                                                    onChange={handleAuditFrequencyChange}
                                                                >
                                                                    {auditFrequencyList.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)}

                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.auditFrequencyId?.message}
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={8} sm={8} md={8}>
                                                    {otherAuditShow && (
                                                        <TextField
                                                            fullWidth
                                                            // disabled={!currentUser.isSuperAdmin}
                                                            InputLabelProps={{ shrink: true }}
                                                            id="auditFrequencyOther"
                                                            name="auditFrequencyOther"
                                                            label="Other"
                                                            placeholder="Other"
                                                            {...register('auditFrequencyOther')}
                                                        />

                                                    )}
                                                    {otherAuditShow && (

                                                        <Typography variant="inherit" color="error.main">
                                                            {errors.auditFrequencyOther?.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={12}  >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            // disabled={!currentUser.isSuperAdmin}
                                                            id="lastAuditDate"
                                                            name="lastAuditDate"
                                                            label="Date of Last Audit"
                                                            {...register('lastAuditDate')}
                                                            value={lastAuditDate}
                                                            onChange={(newValue) => {
                                                                setLastAuditDate(newValue);
                                                                setValue("lastAuditDate", newValue);
                                                            }}
                                                            renderInput={(params) => <TextField  {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.lastAuditDate?.message}
                                                    </Typography>
                                                </Grid>


                                                {/* <Grid item xs={12} sm={12} md={12}>
                                        <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Confirm Compliance With ​Canada’s Data Privacy Act ​And ​PIPEDA​ Request For Mandatory Reporting Of A Data Breach ​“To Inform Individuals If Their Personal Information Has Been Lost, Stolen Or Inappropriately Accessed, And They Are Placed At Risk Of Harm.” Is This Articulated In Terms Of Service?">
                                          <FormControlLabel control={<Switch
                                            // disabled={!currentUser.isSuperAdmin}
                                            checked={dataBreachCompliant ?? false}
                                            onChange={handleDataBreachCompliantChange}
                                            name="dataBreachCompliant"
            
                                          />}
                                            label="Data Breach Compliance"
                                            {...register('dataBreachCompliant')}
                                          />
                                        </Tooltip>
                                      </Grid> */}

                                                <Grid item xs={11} >
                                                    <SelfSizingTextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        initialValue={getValues('dataBackup')}
                                                        errors={errors.dataBackup}
                                                        register={register}
                                                        maxSize={2500}
                                                        name="dataBackup"
                                                        id="dataBackup"
                                                        label="Data Backup and Storage"
                                                        placeholder="How is the data stored and how is it backed up?"
                                                    ></SelfSizingTextField>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="How often is the data backed up and how is it stored?">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>


                                                <Grid item xs={11} >
                                                    <SelfSizingTextField
                                                        // disabled={!currentUser.isSuperAdmin}
                                                        initialValue={getValues('lossProtection')}
                                                        errors={errors.lossProtection}
                                                        register={register}
                                                        maxSize={2500}
                                                        name="lossProtection"
                                                        id="lossProtection"
                                                        label="Data Loss Protection"
                                                        placeholder="How is the data and the data backups protected from loss, theft and/or unauthorized access? (SIEM, encrypted in transit/at rest; password complexity etc.)"
                                                    ></SelfSizingTextField>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="How is the data and the data backups protected from loss, theft and/or unauthorized access? (SIEM, encrypted in transit/at rest; password complexity etc.)">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>


                                                {/* </Grid> */}

                                                <Grid item xs={11}>
                                                    <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="For example, sharing to social media networks">
                                                        <FormControlLabel control={<Switch
                                                            // disabled={!currentUser.isSuperAdmin}
                                                            checked={internetPIPublished ?? false}
                                                            onChange={handleinternetPiChange}
                                                            name="internetPipublished"

                                                        />}
                                                            label="Software allows for publishing of personal information to the internet"
                                                            {...register('internetPipublished')}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Is there a feature of the software that allows posting to the internet, like on their public website or social media?">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>


                                            </Fragment>
                                        }
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('complianceNotes')}
                                                maxSize={2000}
                                                errors={errors.complianceNotes}
                                                register={register}
                                                name="complianceNotes"
                                                id="complianceNotes"
                                                label="Compliance Notes"
                                                placeholder="Compliance Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data compliance information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                    </Grid>


                                </Box>

                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setGenAIOpen(!genAIOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Generative AI
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {otherOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={genAIOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>

                                    <Grid container spacing={2}>
                                        <Grid item xs={6} sm={6} md={6}>

                                            <FormControl>

                                                <FormLabel id="gdpr-label">Does your company rely on external LLMs? </FormLabel>

                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="hasExternalLLMs"
                                                    {...register('hasExternalLLMs')}
                                                    //onChange={handleGdprChange}
                                                    onChange={(e) => {

                                                        handleBooleanRadioButtonChange(e, setHasExternalLLMs);

                                                    }}
                                                >

                                                    <FormControlLabel {...register('hasExternalLLMs')} key='1' value={'1'} checked={hasExternalLLMs} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('hasExternalLLMs')} key='0' value={'0'} checked={hasExternalLLMs === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>

                                        </Grid>

                                        {hasExternalLLMs &&

                                            <Fragment>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmProviders')}
                                                        maxSize={1000}
                                                        errors={errors.LLMProviders}
                                                        register={register}
                                                        name="llmProviders"
                                                        id="llmProviders"
                                                        label="Which Providers are they hosted with?"
                                                        placeholder="Which Providers are they hosted with?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6}>

                                                    <FormControl>

                                                        <FormLabel id="gdpr-label">Do your LLM providers train their general models on the queries submitted? </FormLabel>

                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-radio-buttons-group-label"

                                                            name="llmTraining"
                                                            {...register('llmTraining')}
                                                            //onChange={handleGdprChange}
                                                            onChange={(e) => {

                                                                handleBooleanRadioButtonChange(e, setllmTraining);

                                                            }}
                                                        >

                                                            <FormControlLabel {...register('llmTraining')} key='1' value={'1'} checked={llmTraining} control={<Radio />} label="Yes" />
                                                            <FormControlLabel {...register('llmTraining')} key='0' value={'0'} checked={llmTraining === false} control={<Radio />} label="No" />

                                                        </RadioGroup>
                                                    </FormControl>

                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6}>

                                                    <FormControl>

                                                        <FormLabel id="gdpr-label">Are the models trained with this data shared with other clients? </FormLabel>

                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-radio-buttons-group-label"

                                                            name="llmDataShared"
                                                            {...register('llmDataShared')}
                                                            //onChange={handleGdprChange}
                                                            onChange={(e) => {

                                                                handleBooleanRadioButtonChange(e, setllmDataShared);

                                                            }}
                                                        >

                                                            <FormControlLabel {...register('llmDataShared')} key='1' value={'1'} checked={llmDataShared} control={<Radio />} label="Yes" />
                                                            <FormControlLabel {...register('llmDataShared')} key='0' value={'0'} checked={llmDataShared === false} control={<Radio />} label="No" />

                                                        </RadioGroup>
                                                    </FormControl>

                                                </Grid>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmUnder18Treatment')}
                                                        maxSize={1000}
                                                        errors={errors.llmUnder18Treatment}
                                                        register={register}
                                                        name="llmUnder18Treatment"
                                                        id="llmUnder18Treatment"
                                                        label="Do you treat the data differently if the user is under 18?"
                                                        placeholder="Do you treat the data differently if the user is under 18?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmRestrict')}
                                                        maxSize={1000}
                                                        errors={errors.llmRestrict}
                                                        register={register}
                                                        name="llmRestrict"
                                                        id="llmRestrict"
                                                        label="What approach is taken to restrict access to training and inference data within your organization?"
                                                        placeholder="What approach is taken to restrict access to training and inference data within your organization?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                            </Fragment>
                                        }
                                    </Grid>


                                </Box>

                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setApprovalOpen(!approvalOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Approval
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {approvalOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={approvalOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container>
                                        <Grid item xs={4} sm={4} md={4}>

                                            <FormControlLabel control={<Switch
                                                checked={approved ?? false}
                                                onChange={(event) => handleApprovedChange(event)}
                                                name="approved"

                                            />}
                                                label="Approved"
                                                {...register('approved')}
                                            />
                                            <Tooltip title="Has the school approved the software for use?">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        {approved &&
                                            <Fragment>
                                                <Grid item xs={3} >
                                                    <FormControl sx={{ m: 0, width: 190 }}>
                                                        <InputLabel> Approved By </InputLabel>
                                                        <Controller
                                                            name="approverId"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field: { onChange, value } }) => (
                                                                <Select
                                                                    defaultValue={''}
                                                                    value={value}
                                                                    label="Approved By"
                                                                    onChange={(e) => setValue('approverId', e.target.value, { shouldValidate: true })}
                                                                >
                                                                    {approverList.map((item, index) => <MenuItem key={index} value={item.lookupItemId}>{item.name}</MenuItem>)}

                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.approverId?.message}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "10px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="Who has approved the software?">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>
                                            </Fragment>
                                        }
                                        {approved &&
                                            <Fragment>
                                                <Grid item xs={3} >
                                                    <FormControl sx={{ m: 0, width: 190 }}>
                                                        {/* <InputLabel> Approved By </InputLabel> */}
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                id="approvalDate"
                                                                name="approvalDate"
                                                                label="Approved On"
                                                                {...register('approvalDate')}
                                                                value={approvalDate}
                                                                onChange={(newValue) => {
                                                                    setApprovalDate(newValue);
                                                                    setValue("approvalDate", newValue);
                                                                }}
                                                                renderInput={(params) => <TextField  {...params} />}
                                                            />

                                                        </LocalizationProvider>
                                                        <Typography variant="inherit" color="error.main">
                                                            {errors.approvedDate?.message}
                                                        </Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "10px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="When was this software approved (will show on the list of 'Institutions Approved'.">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>
                                            </Fragment>
                                        }
                                    </Grid>


                                    <Grid container spacing={2}>
                                        <Grid item xs={4} sm={4} md={4}>

                                            <FormControlLabel control={<Switch
                                                checked={notApproved ?? false}
                                                onChange={(event) => handleNotApprovedChange(event)}
                                                name="notApproved"

                                            />}
                                                label="Not Approved"
                                                {...register('notApproved')}
                                            />

                                        </Grid>
                                        <Grid item xs={6} sm={7} md={6}>

                                            {notApproved && (
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    multiline

                                                    id="notApprovedReason"
                                                    name="notApprovedReason"
                                                    label="Rationale for Not Approving"
                                                    placeholder="If the sofware was not approved, describe why"
                                                    //minRows={1}
                                                    fullWidth
                                                    {...register('notApprovedReason')}

                                                />
                                            )}
                                            {notApproved && (
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.notApprovedReason?.message}
                                                </Typography>
                                            )}

                                        </Grid>



                                        <Grid item xs={4} sm={4} md={4}>
                                            {/* <FormControl sx={{ m: 0, width: 250 }}> */}
                                            {/* <InputLabel> Approved By </InputLabel> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id="lastUpdatedDate"
                                                    name="lastUpdatedDate"
                                                    label="Date Last Updated"
                                                    {...register('lastUpdatedDate')}
                                                    value={lastUpdatedDate}
                                                    disabled={true}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />

                                            </LocalizationProvider>

                                            {/* </FormControl> */}

                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <FormControl sx={{ m: 0, width: 250 }}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={true}
                                                    width={250}
                                                    id="completedBy"
                                                    name="completedBy"
                                                    label="Updated By"
                                                    placeholder="Updated By"
                                                    value={completedBy}
                                                    //minRows={1}
                                                    fullWidth


                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Needed for compliance - will need to show re-approval process.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={11} >

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('approvalNotes')}
                                                maxSize={2000}
                                                errors={errors.approvalNotes}
                                                register={register}
                                                name="approvalNotes"
                                                id="approvalNotes"
                                                label="Approval Notes"
                                                placeholder="Approval Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other approval information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>



                                    </Grid>
                                </Box>
                            </Collapse>

                        </Box>

                    </form>
                </DialogContent>
                <DialogActions>
                    {(isSchoolRecord || currentUser.isSuperAdmin) && (
                        <Fragment>
                            {/* <Button color="primary" onClick={handleSubmit(onSubmitSaveOnly)}>Save</Button> */}
                            {/* <Button color="primary" onClick={runValidations}>Validate</Button>   */}
                            <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
                        </Fragment>
                    )}

                    <Button onClick={handleCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Inactivate PIA {deleteName}?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You are marking this application as inactive. To make the application active again, filter by inactive.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleDelete}>Inactivate</Button>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>

        </Box>
        </Fragment>

    );
  
}
